/* eslint-disable no-useless-concat,no-mixed-operators,strict,eqeqeq */
"use strict";
/**
 * Glyphshot Cloud Web Api V1
 * GLYPHSHOT cloud REST API for Web Client version 1
 *
 * OpenAPI spec version: 1.0.0
 * Contact: suganuma@syscli.co.jp
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsApi = exports.UtilsApiApiKeys = exports.SystemApi = exports.SystemApiApiKeys = exports.ProjectsApi = exports.ProjectsApiApiKeys = exports.DocApi = exports.DocApiApiKeys = exports.AuthApi = exports.AuthApiApiKeys = exports.VoidAuth = exports.OAuth = exports.ApiKeyAuth = exports.HttpBasicAuth = exports.Works = exports.WorkGroups = exports.WorkGroup = exports.Work = exports.Users = exports.UserSystemRole = exports.UserOrganizations = exports.UserOrganization = exports.User = exports.UploadTicket = exports.UploadInfo = exports.Trees = exports.TreeLocations = exports.Tree = exports.Token = exports.Time = exports.Templates = exports.Template = exports.SystemRoles = exports.SystemRole = exports.SystemCreateCache = exports.SystemAcl = exports.SasToken = exports.SasPolicyPermission = exports.SasPolicy = exports.Results = exports.Result = exports.ResFiles = exports.ResFile = exports.ReportMap = exports.ReportCheckDate = exports.Report = exports.Registration = exports.Projects = exports.ProjectUsers = exports.ProjectUserProjectRole = exports.ProjectUserInspectionRoles = exports.ProjectUser = exports.ProjectRoles = exports.ProjectRole = exports.ProjectAclProject = exports.ProjectAclInspections = exports.ProjectAcl = exports.Project = exports.ProgressItem = exports.Progress = exports.Preferences = exports.Preference = exports.PasswordReset = exports.Organizations = exports.Organization = exports.Maps = exports.MapFrom = exports.MapFiles = exports.MapFile = exports.Map = exports.Mail = exports.LocationMasters = exports.LocationMaster = exports.Inspections = exports.InspectionRoles = exports.InspectionRole = exports.InspectionModels = exports.InspectionModel = exports.InspectionMasters = exports.InspectionMaster = exports.Inspection = exports.ImportResponseErrors = exports.ImportResponse = exports.ImportModel = exports.Icons = exports.Icon = exports.Helps = exports.Help = exports.Hello = exports.Guides = exports.GuideVertical = exports.GuideP1 = exports.GuideP0 = exports.GuideHorizontal = exports.GuideDiagonal = exports.Guide = exports.GSCError = exports.Floors = exports.FloorHeights = exports.Floor = exports.FilesCount = exports.Files = exports.FileCriteriaMap = exports.FileCriteriaCreated = exports.FileCriteria = exports.File = exports.Downloads = exports.Download = exports.Docs = exports.DocSasToken = exports.DocSasPolicy = exports.DocIndices = exports.DocIndex = exports.Doc = exports.Devices = exports.Device = exports.DefaultWorks = exports.DefaultAcl = exports.AuthToken = exports.Auth = exports.AsyncResponse = exports.Areas = exports.Area = exports.AclInner = exports.Acl = void 0;
var request = require("request");
var Promise = require("bluebird");
var defaultBasePath = 'http://localhost:10010/v1';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
/* tslint:disable:no-unused-variable */
/**
* Access Control List
*/
var Acl = /** @class */ (function (_super) {
    __extends(Acl, _super);
    function Acl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Acl;
}(Array));
exports.Acl = Acl;
/**
* AC
*/
var AclInner = /** @class */ (function () {
    function AclInner() {
    }
    return AclInner;
}());
exports.AclInner = AclInner;
/**
* 工区情報
*/
var Area = /** @class */ (function () {
    function Area() {
    }
    return Area;
}());
exports.Area = Area;
var Areas = /** @class */ (function (_super) {
    __extends(Areas, _super);
    function Areas() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Areas;
}(Array));
exports.Areas = Areas;
/**
* 図面非同期登録レスポンス
*/
var AsyncResponse = /** @class */ (function () {
    function AsyncResponse() {
    }
    return AsyncResponse;
}());
exports.AsyncResponse = AsyncResponse;
/**
* ログインの結果を保持する。
*/
var Auth = /** @class */ (function () {
    function Auth() {
    }
    return Auth;
}());
exports.Auth = Auth;
/**
* ログインの結果を保持する。
*/
var AuthToken = /** @class */ (function () {
    function AuthToken() {
    }
    return AuthToken;
}());
exports.AuthToken = AuthToken;
/**
* 初期設定値保存用 Access Control List
*/
var DefaultAcl = /** @class */ (function () {
    function DefaultAcl() {
    }
    return DefaultAcl;
}());
exports.DefaultAcl = DefaultAcl;
/**
* 初期設定値保存用 工種、工種グループ、所属
*/
var DefaultWorks = /** @class */ (function () {
    function DefaultWorks() {
    }
    return DefaultWorks;
}());
exports.DefaultWorks = DefaultWorks;
/**
* プロジェクトに所属するデバイス情報
*/
var Device = /** @class */ (function () {
    function Device() {
    }
    return Device;
}());
exports.Device = Device;
var Devices = /** @class */ (function (_super) {
    __extends(Devices, _super);
    function Devices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Devices;
}(Array));
exports.Devices = Devices;
/**
* ドキュメント情報
*/
var Doc = /** @class */ (function () {
    function Doc() {
    }
    return Doc;
}());
exports.Doc = Doc;
/**
* 目次情報
*/
var DocIndex = /** @class */ (function () {
    function DocIndex() {
    }
    return DocIndex;
}());
exports.DocIndex = DocIndex;
var DocIndices = /** @class */ (function (_super) {
    __extends(DocIndices, _super);
    function DocIndices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DocIndices;
}(Array));
exports.DocIndices = DocIndices;
/**
* Docコンテナ用SASアクセスポリシー
*/
var DocSasPolicy = /** @class */ (function () {
    function DocSasPolicy() {
    }
    return DocSasPolicy;
}());
exports.DocSasPolicy = DocSasPolicy;
/**
* SASトークン
*/
var DocSasToken = /** @class */ (function () {
    function DocSasToken() {
    }
    return DocSasToken;
}());
exports.DocSasToken = DocSasToken;
var Docs = /** @class */ (function (_super) {
    __extends(Docs, _super);
    function Docs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Docs;
}(Array));
exports.Docs = Docs;
/**
* ダウンロード情報
*/
var Download = /** @class */ (function () {
    function Download() {
    }
    return Download;
}());
exports.Download = Download;
var Downloads = /** @class */ (function (_super) {
    __extends(Downloads, _super);
    function Downloads() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Downloads;
}(Array));
exports.Downloads = Downloads;
/**
* ファイル情報
*/
var File = /** @class */ (function () {
    function File() {
    }
    return File;
}());
exports.File = File;
/**
* ファイル検索条件
*/
var FileCriteria = /** @class */ (function () {
    function FileCriteria() {
    }
    return FileCriteria;
}());
exports.FileCriteria = FileCriteria;
/**
* 撮影日時による絞り込み条件
*/
var FileCriteriaCreated = /** @class */ (function () {
    function FileCriteriaCreated() {
    }
    return FileCriteriaCreated;
}());
exports.FileCriteriaCreated = FileCriteriaCreated;
/**
* 図面情報
*/
var FileCriteriaMap = /** @class */ (function () {
    function FileCriteriaMap() {
    }
    return FileCriteriaMap;
}());
exports.FileCriteriaMap = FileCriteriaMap;
var Files = /** @class */ (function (_super) {
    __extends(Files, _super);
    function Files() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Files;
}(Array));
exports.Files = Files;
/**
* ファイル検索結果件数
*/
var FilesCount = /** @class */ (function () {
    function FilesCount() {
    }
    return FilesCount;
}());
exports.FilesCount = FilesCount;
/**
* 階情報
*/
var Floor = /** @class */ (function () {
    function Floor() {
    }
    return Floor;
}());
exports.Floor = Floor;
/**
* 階情報
*/
var FloorHeights = /** @class */ (function () {
    function FloorHeights() {
    }
    return FloorHeights;
}());
exports.FloorHeights = FloorHeights;
var Floors = /** @class */ (function (_super) {
    __extends(Floors, _super);
    function Floors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Floors;
}(Array));
exports.Floors = Floors;
/**
* エラー情報を保持する。
*/
var GSCError = /** @class */ (function () {
    function GSCError() {
    }
    return GSCError;
}());
exports.GSCError = GSCError;
/**
* 通り芯情報
*/
var Guide = /** @class */ (function () {
    function Guide() {
    }
    return Guide;
}());
exports.Guide = Guide;
/**
* 1次関数通り芯
*/
var GuideDiagonal = /** @class */ (function () {
    function GuideDiagonal() {
    }
    return GuideDiagonal;
}());
exports.GuideDiagonal = GuideDiagonal;
/**
* 水平通り芯
*/
var GuideHorizontal = /** @class */ (function () {
    function GuideHorizontal() {
    }
    return GuideHorizontal;
}());
exports.GuideHorizontal = GuideHorizontal;
var GuideP0 = /** @class */ (function () {
    function GuideP0() {
    }
    return GuideP0;
}());
exports.GuideP0 = GuideP0;
var GuideP1 = /** @class */ (function () {
    function GuideP1() {
    }
    return GuideP1;
}());
exports.GuideP1 = GuideP1;
/**
* 垂直通り芯
*/
var GuideVertical = /** @class */ (function () {
    function GuideVertical() {
    }
    return GuideVertical;
}());
exports.GuideVertical = GuideVertical;
var Guides = /** @class */ (function (_super) {
    __extends(Guides, _super);
    function Guides() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Guides;
}(Array));
exports.Guides = Guides;
/**
* 返信メッセージを保持する。
*/
var Hello = /** @class */ (function () {
    function Hello() {
    }
    return Hello;
}());
exports.Hello = Hello;
/**
* ヘルプ
*/
var Help = /** @class */ (function () {
    function Help() {
    }
    return Help;
}());
exports.Help = Help;
var Helps = /** @class */ (function (_super) {
    __extends(Helps, _super);
    function Helps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Helps;
}(Array));
exports.Helps = Helps;
/**
* アイコン情報
*/
var Icon = /** @class */ (function () {
    function Icon() {
    }
    return Icon;
}());
exports.Icon = Icon;
var Icons = /** @class */ (function (_super) {
    __extends(Icons, _super);
    function Icons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Icons;
}(Array));
exports.Icons = Icons;
/**
* 一括登録データ
*/
var ImportModel = /** @class */ (function () {
    function ImportModel() {
    }
    return ImportModel;
}());
exports.ImportModel = ImportModel;
/**
* 一括登録の結果
*/
var ImportResponse = /** @class */ (function () {
    function ImportResponse() {
    }
    return ImportResponse;
}());
exports.ImportResponse = ImportResponse;
/**
* エラー情報
*/
var ImportResponseErrors = /** @class */ (function () {
    function ImportResponseErrors() {
    }
    return ImportResponseErrors;
}());
exports.ImportResponseErrors = ImportResponseErrors;
/**
* 検査情報
*/
var Inspection = /** @class */ (function () {
    function Inspection() {
    }
    return Inspection;
}());
exports.Inspection = Inspection;
/**
* 検査マスター
*/
var InspectionMaster = /** @class */ (function () {
    function InspectionMaster() {
    }
    return InspectionMaster;
}());
exports.InspectionMaster = InspectionMaster;
var InspectionMasters = /** @class */ (function (_super) {
    __extends(InspectionMasters, _super);
    function InspectionMasters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InspectionMasters;
}(Array));
exports.InspectionMasters = InspectionMasters;
/**
* 検査モデル情報
*/
var InspectionModel = /** @class */ (function () {
    function InspectionModel() {
    }
    return InspectionModel;
}());
exports.InspectionModel = InspectionModel;
var InspectionModels = /** @class */ (function (_super) {
    __extends(InspectionModels, _super);
    function InspectionModels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InspectionModels;
}(Array));
exports.InspectionModels = InspectionModels;
/**
* 検査ロール
*/
var InspectionRole = /** @class */ (function () {
    function InspectionRole() {
    }
    return InspectionRole;
}());
exports.InspectionRole = InspectionRole;
var InspectionRoles = /** @class */ (function (_super) {
    __extends(InspectionRoles, _super);
    function InspectionRoles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InspectionRoles;
}(Array));
exports.InspectionRoles = InspectionRoles;
var Inspections = /** @class */ (function (_super) {
    __extends(Inspections, _super);
    function Inspections() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Inspections;
}(Array));
exports.Inspections = Inspections;
/**
* 場所プロパティマスター情報
*/
var LocationMaster = /** @class */ (function () {
    function LocationMaster() {
    }
    return LocationMaster;
}());
exports.LocationMaster = LocationMaster;
var LocationMasters = /** @class */ (function (_super) {
    __extends(LocationMasters, _super);
    function LocationMasters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LocationMasters;
}(Array));
exports.LocationMasters = LocationMasters;
/**
* メール送信情報
*/
var Mail = /** @class */ (function () {
    function Mail() {
    }
    return Mail;
}());
exports.Mail = Mail;
/**
* マップ情報
*/
var Map = /** @class */ (function () {
    function Map() {
    }
    return Map;
}());
exports.Map = Map;
/**
* 図面情報
*/
var MapFile = /** @class */ (function () {
    function MapFile() {
    }
    return MapFile;
}());
exports.MapFile = MapFile;
var MapFiles = /** @class */ (function (_super) {
    __extends(MapFiles, _super);
    function MapFiles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MapFiles;
}(Array));
exports.MapFiles = MapFiles;
/**
* マップ情報
*/
var MapFrom = /** @class */ (function () {
  function MapFrom() {
  }
  return MapFrom;
}());
exports.MapFrom = MapFrom;
var Maps = /** @class */ (function (_super) {
    __extends(Maps, _super);
    function Maps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Maps;
}(Array));
exports.Maps = Maps;
/**
* 所属情報
*/
var Organization = /** @class */ (function () {
    function Organization() {
    }
    return Organization;
}());
exports.Organization = Organization;
var Organizations = /** @class */ (function (_super) {
    __extends(Organizations, _super);
    function Organizations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Organizations;
}(Array));
exports.Organizations = Organizations;
/**
* 登録情報
*/
var PasswordReset = /** @class */ (function () {
    function PasswordReset() {
    }
    return PasswordReset;
}());
exports.PasswordReset = PasswordReset;
/**
* 設定情報
*/
var Preference = /** @class */ (function () {
    function Preference() {
    }
    return Preference;
}());
exports.Preference = Preference;
var Preferences = /** @class */ (function (_super) {
    __extends(Preferences, _super);
    function Preferences() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Preferences;
}(Array));
exports.Preferences = Preferences;
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Progress;
}(Array));
exports.Progress = Progress;
/**
* 進行状況
*/
var ProgressItem = /** @class */ (function () {
    function ProgressItem() {
    }
    return ProgressItem;
}());
exports.ProgressItem = ProgressItem;
/**
* プロジェクト情報
*/
var Project = /** @class */ (function () {
    function Project() {
    }
    return Project;
}());
exports.Project = Project;
/**
* プロジェクトACL
*/
var ProjectAcl = /** @class */ (function () {
    function ProjectAcl() {
    }
    return ProjectAcl;
}());
exports.ProjectAcl = ProjectAcl;
/**
* 検査権限
*/
var ProjectAclInspections = /** @class */ (function () {
    function ProjectAclInspections() {
    }
    return ProjectAclInspections;
}());
exports.ProjectAclInspections = ProjectAclInspections;
var ProjectAclProject = /** @class */ (function () {
    function ProjectAclProject() {
    }
    return ProjectAclProject;
}());
exports.ProjectAclProject = ProjectAclProject;
/**
* プロジェクトロール
*/
var ProjectRole = /** @class */ (function () {
    function ProjectRole() {
    }
    return ProjectRole;
}());
exports.ProjectRole = ProjectRole;
var ProjectRoles = /** @class */ (function (_super) {
    __extends(ProjectRoles, _super);
    function ProjectRoles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectRoles;
}(Array));
exports.ProjectRoles = ProjectRoles;
/**
* プロジェクトに所属するユーザ情報
*/
var ProjectUser = /** @class */ (function () {
    function ProjectUser() {
    }
    return ProjectUser;
}());
exports.ProjectUser = ProjectUser;
var ProjectUserInspectionRoles = /** @class */ (function () {
    function ProjectUserInspectionRoles() {
    }
    return ProjectUserInspectionRoles;
}());
exports.ProjectUserInspectionRoles = ProjectUserInspectionRoles;
var ProjectUserProjectRole = /** @class */ (function () {
    function ProjectUserProjectRole() {
    }
    return ProjectUserProjectRole;
}());
exports.ProjectUserProjectRole = ProjectUserProjectRole;
var ProjectUsers = /** @class */ (function (_super) {
    __extends(ProjectUsers, _super);
    function ProjectUsers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectUsers;
}(Array));
exports.ProjectUsers = ProjectUsers;
var Projects = /** @class */ (function (_super) {
    __extends(Projects, _super);
    function Projects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Projects;
}(Array));
exports.Projects = Projects;
/**
* 登録情報
*/
var Registration = /** @class */ (function () {
    function Registration() {
    }
    return Registration;
}());
exports.Registration = Registration;
/**
* プロジェクト情報
*/
var Report = /** @class */ (function () {
    function Report() {
    }
    return Report;
}());
exports.Report = Report;
/**
* 検査日による絞り込み条件
*/
var ReportCheckDate = /** @class */ (function () {
    function ReportCheckDate() {
    }
    return ReportCheckDate;
}());
exports.ReportCheckDate = ReportCheckDate;
/**
* 図面情報
*/
var ReportMap = /** @class */ (function () {
    function ReportMap() {
    }
    return ReportMap;
}());
exports.ReportMap = ReportMap;
/**
* 資料情報
*/
var ResFile = /** @class */ (function () {
    function ResFile() {
    }
    return ResFile;
}());
exports.ResFile = ResFile;
var ResFiles = /** @class */ (function (_super) {
    __extends(ResFiles, _super);
    function ResFiles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ResFiles;
}(Array));
exports.ResFiles = ResFiles;
/**
* 検査結果情報
*/
var Result = /** @class */ (function () {
    function Result() {
    }
    return Result;
}());
exports.Result = Result;
var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Results;
}(Array));
exports.Results = Results;
/**
* アクセスポリシー
*/
var SasPolicy = /** @class */ (function () {
    function SasPolicy() {
    }
    return SasPolicy;
}());
exports.SasPolicy = SasPolicy;
var SasPolicyPermission = /** @class */ (function () {
    function SasPolicyPermission() {
    }
    return SasPolicyPermission;
}());
exports.SasPolicyPermission = SasPolicyPermission;
/**
* SASトークン
*/
var SasToken = /** @class */ (function () {
    function SasToken() {
    }
    return SasToken;
}());
exports.SasToken = SasToken;
/**
* Access Control List
*/
var SystemAcl = /** @class */ (function (_super) {
    __extends(SystemAcl, _super);
    function SystemAcl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SystemAcl;
}(Array));
exports.SystemAcl = SystemAcl;
/**
* 処理の起動に成功したかどうかを保持する。
*/
var SystemCreateCache = /** @class */ (function () {
    function SystemCreateCache() {
    }
    return SystemCreateCache;
}());
exports.SystemCreateCache = SystemCreateCache;
/**
* システムロール
*/
var SystemRole = /** @class */ (function () {
    function SystemRole() {
    }
    return SystemRole;
}());
exports.SystemRole = SystemRole;
var SystemRoles = /** @class */ (function (_super) {
    __extends(SystemRoles, _super);
    function SystemRoles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SystemRoles;
}(Array));
exports.SystemRoles = SystemRoles;
/**
* 帳票テンプレート
*/
var Template = /** @class */ (function () {
    function Template() {
    }
    return Template;
}());
exports.Template = Template;
var Templates = /** @class */ (function (_super) {
    __extends(Templates, _super);
    function Templates() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Templates;
}(Array));
exports.Templates = Templates;
/**
* 現在時刻を保持する。ISO8601(yyyy-MM-ddTHH:mm:ss.000Z)形式の文字列が返される。
*/
var Time = /** @class */ (function () {
    function Time() {
    }
    return Time;
}());
exports.Time = Time;
/**
* ログインの結果を保持する。
*/
var Token = /** @class */ (function () {
    function Token() {
    }
    return Token;
}());
exports.Token = Token;
/**
* ツリー情報
*/
var Tree = /** @class */ (function () {
    function Tree() {
    }
    return Tree;
}());
exports.Tree = Tree;
/**
* 場所プロパティ
*/
var TreeLocations = /** @class */ (function () {
    function TreeLocations() {
    }
    return TreeLocations;
}());
exports.TreeLocations = TreeLocations;
var Trees = /** @class */ (function (_super) {
    __extends(Trees, _super);
    function Trees() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Trees;
}(Array));
exports.Trees = Trees;
/**
* ファイルアップロード先取得
*/
var UploadInfo = /** @class */ (function () {
    function UploadInfo() {
    }
    return UploadInfo;
}());
exports.UploadInfo = UploadInfo;
/**
* ファイルアップロード先情報 https://{hostName}/{containerName}/{blobName}{sasToken}
*/
var UploadTicket = /** @class */ (function () {
    function UploadTicket() {
    }
    return UploadTicket;
}());
exports.UploadTicket = UploadTicket;
/**
* ユーザ情報
*/
var User = /** @class */ (function () {
    function User() {
    }
    return User;
}());
exports.User = User;
/**
* ユーザ・所属関係情報
*/
var UserOrganization = /** @class */ (function () {
    function UserOrganization() {
    }
    return UserOrganization;
}());
exports.UserOrganization = UserOrganization;
var UserOrganizations = /** @class */ (function (_super) {
    __extends(UserOrganizations, _super);
    function UserOrganizations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserOrganizations;
}(Array));
exports.UserOrganizations = UserOrganizations;
var UserSystemRole = /** @class */ (function () {
    function UserSystemRole() {
    }
    return UserSystemRole;
}());
exports.UserSystemRole = UserSystemRole;
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Users;
}(Array));
exports.Users = Users;
/**
* 工種情報
*/
var Work = /** @class */ (function () {
    function Work() {
    }
    return Work;
}());
exports.Work = Work;
/**
* 工種グループ情報
*/
var WorkGroup = /** @class */ (function () {
    function WorkGroup() {
    }
    return WorkGroup;
}());
exports.WorkGroup = WorkGroup;
var WorkGroups = /** @class */ (function (_super) {
    __extends(WorkGroups, _super);
    function WorkGroups() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WorkGroups;
}(Array));
exports.WorkGroups = WorkGroups;
var Works = /** @class */ (function (_super) {
    __extends(Works, _super);
    function Works() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Works;
}(Array));
exports.Works = Works;
var HttpBasicAuth = /** @class */ (function () {
    function HttpBasicAuth() {
    }
    HttpBasicAuth.prototype.applyToRequest = function (requestOptions) {
        requestOptions.auth = {
            username: this.username, password: this.password
        };
    };
    return HttpBasicAuth;
}());
exports.HttpBasicAuth = HttpBasicAuth;
var ApiKeyAuth = /** @class */ (function () {
    function ApiKeyAuth(location, paramName) {
        this.location = location;
        this.paramName = paramName;
    }
    ApiKeyAuth.prototype.applyToRequest = function (requestOptions) {
        if (this.location == "query") {
            requestOptions.qs[this.paramName] = this.apiKey;
        }
        else if (this.location == "header" && requestOptions && requestOptions.headers) {
            requestOptions.headers[this.paramName] = this.apiKey;
        }
    };
    return ApiKeyAuth;
}());
exports.ApiKeyAuth = ApiKeyAuth;
var OAuth = /** @class */ (function () {
    function OAuth() {
    }
    OAuth.prototype.applyToRequest = function (requestOptions) {
        if (requestOptions && requestOptions.headers) {
            requestOptions.headers["Authorization"] = "Bearer " + this.accessToken;
        }
    };
    return OAuth;
}());
exports.OAuth = OAuth;
var VoidAuth = /** @class */ (function () {
    function VoidAuth() {
    }
    VoidAuth.prototype.applyToRequest = function (_) {
        // Do nothing
    };
    return VoidAuth;
}());
exports.VoidAuth = VoidAuth;
var AuthApiApiKeys;
(function (AuthApiApiKeys) {
    AuthApiApiKeys[AuthApiApiKeys["Bearer"] = 0] = "Bearer";
})(AuthApiApiKeys = exports.AuthApiApiKeys || (exports.AuthApiApiKeys = {}));
var AuthApi = /** @class */ (function () {
    function AuthApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(AuthApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    AuthApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    AuthApi.prototype.setApiKey = function (key, value) {
        this.authentications[AuthApiApiKeys[key]].apiKey = value;
    };
    /**
     * トークン確認
     * @param token トークン
     */
    AuthApi.prototype.confirmRegistration = function (token) {
        var localVarPath = this.basePath + '/registration';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'token' is not null or undefined
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling confirmRegistration.');
        }
        if (token !== undefined) {
            queryParameters['token'] = token;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * トークン確認
     * @param token トークン
     */
    AuthApi.prototype.confirmToken = function (token) {
        var localVarPath = this.basePath + '/passwordReset';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'token' is not null or undefined
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling confirmToken.');
        }
        if (token !== undefined) {
            queryParameters['token'] = token;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ログインを実行する。
     * @param authentication
     */
    AuthApi.prototype.login = function (authentication) {
        var localVarPath = this.basePath + '/login';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'authentication' is not null or undefined
        if (authentication === null || authentication === undefined) {
            throw new Error('Required parameter authentication was null or undefined when calling login.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: authentication,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * tokenによるログインを実行する。
     * @param authentication
     */
    AuthApi.prototype.loginByToken = function (authentication) {
        var localVarPath = this.basePath + '/token';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'authentication' is not null or undefined
        if (authentication === null || authentication === undefined) {
            throw new Error('Required parameter authentication was null or undefined when calling loginByToken.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: authentication,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ログアウトを実行する。
     */
    AuthApi.prototype.logout = function () {
        var localVarPath = this.basePath + '/logout';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * パスワードリセットメール送信
     * @param email メールアドレス
     */
    AuthApi.prototype.passwordResetMailSend = function (email) {
        var localVarPath = this.basePath + '/passwordReset';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'email' is not null or undefined
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling passwordResetMailSend.');
        }
        if (email !== undefined) {
            queryParameters['email'] = email;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザー仮登録
     * @param email メールアドレス
     */
    AuthApi.prototype.provisionalRegistration = function (email) {
        var localVarPath = this.basePath + '/registration';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'email' is not null or undefined
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling provisionalRegistration.');
        }
        if (email !== undefined) {
            queryParameters['email'] = email;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 新規パスワード設定
     * @param token トークン
     * @param passwordReset ユーザ
     */
    AuthApi.prototype.resetPassword = function (token, passwordReset) {
        var localVarPath = this.basePath + '/passwordReset';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'token' is not null or undefined
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling resetPassword.');
        }
        // verify required parameter 'passwordReset' is not null or undefined
        if (passwordReset === null || passwordReset === undefined) {
            throw new Error('Required parameter passwordReset was null or undefined when calling resetPassword.');
        }
        if (token !== undefined) {
            queryParameters['token'] = token;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: passwordReset,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * JWTトークンを指定してユーザを取得する。
     */
    AuthApi.prototype.userByToken = function () {
        var localVarPath = this.basePath + '/userByToken';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザ登録
     * @param token トークン
     * @param user ユーザ
     */
    AuthApi.prototype.userRegistration = function (token, user) {
        var localVarPath = this.basePath + '/registration';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'token' is not null or undefined
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling userRegistration.');
        }
        // verify required parameter 'user' is not null or undefined
        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling userRegistration.');
        }
        if (token !== undefined) {
            queryParameters['token'] = token;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: user,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return AuthApi;
}());
exports.AuthApi = AuthApi;
var DocApiApiKeys;
(function (DocApiApiKeys) {
    DocApiApiKeys[DocApiApiKeys["Bearer"] = 0] = "Bearer";
})(DocApiApiKeys = exports.DocApiApiKeys || (exports.DocApiApiKeys = {}));
var DocApi = /** @class */ (function () {
    function DocApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(DocApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    DocApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    DocApi.prototype.setApiKey = function (key, value) {
        this.authentications[DocApiApiKeys[key]].apiKey = value;
    };
    /**
     * ストレージに保存されている添付ファイルを取得する。gscstorageaccountのdocコンテナ以下にある「name」ファイルを取得し、ファイルの内容をレスポンスとして返す。
     * @param name 添付ファイル名称
     */
    DocApi.prototype.attachmentByName = function (name) {
        var localVarPath = this.basePath + '/attachment/{name}'
            .replace('{' + 'name' + '}', String(name));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'name' is not null or undefined
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling attachmentByName.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            encoding: null,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ドキュメント識別子を指定してドキュメントを削除する。
     * @param did ドキュメント識別子
     */
    DocApi.prototype.deleteDoc = function (did) {
        var localVarPath = this.basePath + '/docs/{did}'
            .replace('{' + 'did' + '}', String(did));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'did' is not null or undefined
        if (did === null || did === undefined) {
            throw new Error('Required parameter did was null or undefined when calling deleteDoc.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 目次識別子を指定して目次を削除する。
     * @param iid 目次識別子
     */
    DocApi.prototype.deleteDocIndex = function (iid) {
        var localVarPath = this.basePath + '/docindices/{iid}'
            .replace('{' + 'iid' + '}', String(iid));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'iid' is not null or undefined
        if (iid === null || iid === undefined) {
            throw new Error('Required parameter iid was null or undefined when calling deleteDocIndex.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ドキュメント識別子を指定してドキュメントを取得する。
     * @param did ドキュメント識別子
     */
    DocApi.prototype.docByDID = function (did) {
        var localVarPath = this.basePath + '/docs/{did}'
            .replace('{' + 'did' + '}', String(did));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'did' is not null or undefined
        if (did === null || did === undefined) {
            throw new Error('Required parameter did was null or undefined when calling docByDID.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 目次識別子を指定して目次を取得する。
     * @param iid 目次識別子
     */
    DocApi.prototype.docIndexByIID = function (iid) {
        var localVarPath = this.basePath + '/docindices/{iid}'
            .replace('{' + 'iid' + '}', String(iid));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'iid' is not null or undefined
        if (iid === null || iid === undefined) {
            throw new Error('Required parameter iid was null or undefined when calling docIndexByIID.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * DocコンテナにアクセスするためのSASトークンを取得する。
     * @param docSasPolicy アクセスポリシー
     */
    DocApi.prototype.docSasToken = function (docSasPolicy) {
        var localVarPath = this.basePath + '/docSasToken';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'docSasPolicy' is not null or undefined
        if (docSasPolicy === null || docSasPolicy === undefined) {
            throw new Error('Required parameter docSasPolicy was null or undefined when calling docSasToken.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: docSasPolicy,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 目次一覧を取得する。
     */
    DocApi.prototype.getDocIndices = function () {
        var localVarPath = this.basePath + '/docindices';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ドキュメント一覧を取得する。
     */
    DocApi.prototype.getDocs = function () {
        var localVarPath = this.basePath + '/docs';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ドキュメントを作成する。
     * @param doc ドキュメント情報
     */
    DocApi.prototype.postDoc = function (doc) {
        var localVarPath = this.basePath + '/docs';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'doc' is not null or undefined
        if (doc === null || doc === undefined) {
            throw new Error('Required parameter doc was null or undefined when calling postDoc.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: doc,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 目次を作成する。
     * @param docIndex 目次情報
     */
    DocApi.prototype.postDocIndex = function (docIndex) {
        var localVarPath = this.basePath + '/docindices';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'docIndex' is not null or undefined
        if (docIndex === null || docIndex === undefined) {
            throw new Error('Required parameter docIndex was null or undefined when calling postDocIndex.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: docIndex,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ドキュメントを更新する。
     * @param did ドキュメント識別子
     * @param doc ドキュメント情報
     */
    DocApi.prototype.putDoc = function (did, doc) {
        var localVarPath = this.basePath + '/docs/{did}'
            .replace('{' + 'did' + '}', String(did));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'did' is not null or undefined
        if (did === null || did === undefined) {
            throw new Error('Required parameter did was null or undefined when calling putDoc.');
        }
        // verify required parameter 'doc' is not null or undefined
        if (doc === null || doc === undefined) {
            throw new Error('Required parameter doc was null or undefined when calling putDoc.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: doc,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 目次を更新する。
     * @param iid 目次識別子
     * @param docIndex 目次情報
     */
    DocApi.prototype.putDocIndex = function (iid, docIndex) {
        var localVarPath = this.basePath + '/docindices/{iid}'
            .replace('{' + 'iid' + '}', String(iid));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'iid' is not null or undefined
        if (iid === null || iid === undefined) {
            throw new Error('Required parameter iid was null or undefined when calling putDocIndex.');
        }
        // verify required parameter 'docIndex' is not null or undefined
        if (docIndex === null || docIndex === undefined) {
            throw new Error('Required parameter docIndex was null or undefined when calling putDocIndex.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: docIndex,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return DocApi;
}());
exports.DocApi = DocApi;
var ProjectsApiApiKeys;
(function (ProjectsApiApiKeys) {
    ProjectsApiApiKeys[ProjectsApiApiKeys["Bearer"] = 0] = "Bearer";
})(ProjectsApiApiKeys = exports.ProjectsApiApiKeys || (exports.ProjectsApiApiKeys = {}));
var ProjectsApi = /** @class */ (function () {
    function ProjectsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(ProjectsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    ProjectsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    ProjectsApi.prototype.setApiKey = function (key, value) {
        this.authentications[ProjectsApiApiKeys[key]].apiKey = value;
    };
    /**
     * データをインポートする
     * @param projectId プロジェクトID
     * @param type データの種類
     * @param data JSONデータ
     */
    ProjectsApi.prototype._import = function (projectId, type, data) {
        var localVarPath = this.basePath + '/projects/{projectId}/import/{type}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'type' + '}', String(type));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling _import.');
        }
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling _import.');
        }
        // verify required parameter 'data' is not null or undefined
        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling _import.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: data,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工区を取得する。
     * @param projectId プロジェクトID
     * @param areaId 工区ID
     */
    ProjectsApi.prototype.areaById = function (projectId, areaId) {
        var localVarPath = this.basePath + '/projects/{projectId}/areas/{areaId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'areaId' + '}', String(areaId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling areaById.');
        }
        // verify required parameter 'areaId' is not null or undefined
        if (areaId === null || areaId === undefined) {
            throw new Error('Required parameter areaId was null or undefined when calling areaById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 処理をキャンセルする
     * @param projectId プロジェクトID
     * @param progressKey キー
     */
    ProjectsApi.prototype.cancelProgress = function (projectId, progressKey) {
        var localVarPath = this.basePath + '/projects/{projectId}/progress/{progressKey}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'progressKey' + '}', String(progressKey));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling cancelProgress.');
        }
        // verify required parameter 'progressKey' is not null or undefined
        if (progressKey === null || progressKey === undefined) {
            throw new Error('Required parameter progressKey was null or undefined when calling cancelProgress.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 写真の検索結果数を取得する。
     * @param projectId プロジェクトID
     * @param criteria 写真検索情報
     */
    ProjectsApi.prototype.countFiles = function (projectId, criteria) {
        var localVarPath = this.basePath + '/projects/{projectId}/files/count'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling countFiles.');
        }
        // verify required parameter 'criteria' is not null or undefined
        if (criteria === null || criteria === undefined) {
            throw new Error('Required parameter criteria was null or undefined when calling countFiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: criteria,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * アイコンを作成する。
     * @param projectId プロジェクトID
     * @param icon アイコン
     */
    ProjectsApi.prototype.createIcon = function (projectId, icon) {
        var localVarPath = this.basePath + '/projects/{projectId}/icons'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createIcon.');
        }
        // verify required parameter 'icon' is not null or undefined
        if (icon === null || icon === undefined) {
            throw new Error('Required parameter icon was null or undefined when calling createIcon.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: icon,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザを管理者としてプロジェクトに追加する。
     * @param projectId プロジェクトID
     * @param email ユーザメールアドレス
     */
    ProjectsApi.prototype.createProjectAdministrator = function (projectId, email) {
        var localVarPath = this.basePath + '/projects/{projectId}/user'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createProjectAdministrator.');
        }
        // verify required parameter 'email' is not null or undefined
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling createProjectAdministrator.');
        }
        if (email !== undefined) {
            queryParameters['email'] = email;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票の設定に使用するアイコン一覧を取得する。
     * @param projectId プロジェクトID
     * @param report 帳票情報
     */
    ProjectsApi.prototype.getReportIcons = function (projectId, report) {
        var localVarPath = this.basePath + '/projects/{projectId}/reports/icons'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getReportIcons.');
        }
        // verify required parameter 'report' is not null or undefined
        if (report === null || report === undefined) {
            throw new Error('Required parameter report was null or undefined when calling getReportIcons.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: report,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票を生成する。
     * @param projectId プロジェクトID
     * @param report 帳票情報
     */
    ProjectsApi.prototype.createReport = function (projectId, report) {
        var localVarPath = this.basePath + '/projects/{projectId}/reports'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createReport.');
        }
        // verify required parameter 'report' is not null or undefined
        if (report === null || report === undefined) {
            throw new Error('Required parameter report was null or undefined when calling createReport.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: report,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工区を削除する。
     * @param projectId プロジェクトID
     * @param areaId 工区ID
     */
    ProjectsApi.prototype.deleteArea = function (projectId, areaId) {
        var localVarPath = this.basePath + '/projects/{projectId}/areas/{areaId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'areaId' + '}', String(areaId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteArea.');
        }
        // verify required parameter 'areaId' is not null or undefined
        if (areaId === null || areaId === undefined) {
            throw new Error('Required parameter areaId was null or undefined when calling deleteArea.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してデバイスの登録をプロジェクトから削除する。
     * @param projectId プロジェクトID
     * @param deviceId デバイスID
     */
    ProjectsApi.prototype.deleteDevice = function (projectId, deviceId) {
        var localVarPath = this.basePath + '/projects/{projectId}/devices/{deviceId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'deviceId' + '}', String(deviceId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteDevice.');
        }
        // verify required parameter 'deviceId' is not null or undefined
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling deleteDevice.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してダウンロードを削除する。
     * @param projectId プロジェクトID
     * @param downloadId ダウンロードID
     */
    ProjectsApi.prototype.deleteDownload = function (projectId, downloadId) {
        var localVarPath = this.basePath + '/projects/{projectId}/downloads/{downloadId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'downloadId' + '}', String(downloadId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteDownload.');
        }
        // verify required parameter 'downloadId' is not null or undefined
        if (downloadId === null || downloadId === undefined) {
            throw new Error('Required parameter downloadId was null or undefined when calling deleteDownload.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して階を削除する。
     * @param projectId プロジェクトID
     * @param floorId 階ID
     */
    ProjectsApi.prototype.deleteFloor = function (projectId, floorId) {
        var localVarPath = this.basePath + '/projects/{projectId}/floors/{floorId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'floorId' + '}', String(floorId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteFloor.');
        }
        // verify required parameter 'floorId' is not null or undefined
        if (floorId === null || floorId === undefined) {
            throw new Error('Required parameter floorId was null or undefined when calling deleteFloor.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して通り芯を削除する。
     * @param projectId プロジェクトID
     * @param guideId 通り芯ID
     */
    ProjectsApi.prototype.deleteGuide = function (projectId, guideId) {
        var localVarPath = this.basePath + '/projects/{projectId}/guides/{guideId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'guideId' + '}', String(guideId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteGuide.');
        }
        // verify required parameter 'guideId' is not null or undefined
        if (guideId === null || guideId === undefined) {
            throw new Error('Required parameter guideId was null or undefined when calling deleteGuide.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してアイコンを削除する。
     * @param projectId プロジェクトID
     * @param iconId アイコンID
     */
    ProjectsApi.prototype.deleteIcon = function (projectId, iconId) {
        var localVarPath = this.basePath + '/projects/{projectId}/icons/{iconId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'iconId' + '}', String(iconId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteIcon.');
        }
        // verify required parameter 'iconId' is not null or undefined
        if (iconId === null || iconId === undefined) {
            throw new Error('Required parameter iconId was null or undefined when calling deleteIcon.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して検査を削除する。
     * @param projectId プロジェクトID
     * @param inspectionId 検査ID
     */
    ProjectsApi.prototype.deleteInspection = function (projectId, inspectionId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections/{inspectionId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionId' + '}', String(inspectionId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteInspection.');
        }
        // verify required parameter 'inspectionId' is not null or undefined
        if (inspectionId === null || inspectionId === undefined) {
            throw new Error('Required parameter inspectionId was null or undefined when calling deleteInspection.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して検査ロールを削除する。
     * @param projectId プロジェクトID
     * @param inspectionRoleId 検査ロールID
     */
    ProjectsApi.prototype.deleteInspectionRole = function (projectId, inspectionRoleId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspectionRoles/{inspectionRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionRoleId' + '}', String(inspectionRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteInspectionRole.');
        }
        // verify required parameter 'inspectionRoleId' is not null or undefined
        if (inspectionRoleId === null || inspectionRoleId === undefined) {
            throw new Error('Required parameter inspectionRoleId was null or undefined when calling deleteInspectionRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して場所プロパティマスターを削除する。
     * @param projectId プロジェクトID
     * @param locationMasterId 場所プロパティマスターID
     */
    ProjectsApi.prototype.deleteLocationMaster = function (projectId, locationMasterId) {
        var localVarPath = this.basePath + '/projects/{projectId}/locationMasters/{locationMasterId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'locationMasterId' + '}', String(locationMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteLocationMaster.');
        }
        // verify required parameter 'locationMasterId' is not null or undefined
        if (locationMasterId === null || locationMasterId === undefined) {
            throw new Error('Required parameter locationMasterId was null or undefined when calling deleteLocationMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してマップを削除する。
     * @param projectId プロジェクトID
     * @param mapId マップID
     */
    ProjectsApi.prototype.deleteMap = function (projectId, mapId) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps/{mapId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapId' + '}', String(mapId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteMap.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling deleteMap.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して図面を削除する。
     * @param projectId プロジェクトID
     * @param mapFileId 図面ID
     */
    ProjectsApi.prototype.deleteMapfile = function (projectId, mapFileId) {
        var localVarPath = this.basePath + '/projects/{projectId}/mapFiles/{mapFileId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapFileId' + '}', String(mapFileId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteMapfile.');
        }
        // verify required parameter 'mapFileId' is not null or undefined
        if (mapFileId === null || mapFileId === undefined) {
            throw new Error('Required parameter mapFileId was null or undefined when calling deleteMapfile.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して所属を削除する。
     * @param projectId プロジェクトID
     * @param organizationId 所属ID
     */
    ProjectsApi.prototype.deleteOrganization = function (projectId, organizationId) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations/{organizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'organizationId' + '}', String(organizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteOrganization.');
        }
        // verify required parameter 'organizationId' is not null or undefined
        if (organizationId === null || organizationId === undefined) {
            throw new Error('Required parameter organizationId was null or undefined when calling deleteOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 処理結果を削除する
     * @param projectId プロジェクトID
     * @param progressKey キー
     */
    ProjectsApi.prototype.deleteProgress = function (projectId, progressKey) {
        var localVarPath = this.basePath + '/projects/{projectId}/progress/{progressKey}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'progressKey' + '}', String(progressKey));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteProgress.');
        }
        // verify required parameter 'progressKey' is not null or undefined
        if (progressKey === null || progressKey === undefined) {
            throw new Error('Required parameter progressKey was null or undefined when calling deleteProgress.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     プロジェクトを削除する。   </dd>   <dt>signature</dt>   <dd>     DELETE /v1/projects/{id}   </dd>   <dt>parameters</dt>   <dd>     システム管理者がプロジェクトを削除する。     pathで指定されたIDのプロジェクト情報をすべて（DBのデータ、ストレージのデータを含む）削除する。     SYSTEM_DELETE_PROJECTを持つ場合に実行が可能。     このメソッドでは実際にプロジェクトを削除する。WebUIに実装する見かけ上の削除はPUT（変更）によるstate変更で行う。   </dd> </dl>
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.deleteProject = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteProject.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してプロジェクトロールを削除する。
     * @param projectId プロジェクトID
     * @param projectRoleId プロジェクトロールID
     */
    ProjectsApi.prototype.deleteProjectRole = function (projectId, projectRoleId) {
        var localVarPath = this.basePath + '/projects/{projectId}/projectRoles/{projectRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'projectRoleId' + '}', String(projectRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteProjectRole.');
        }
        // verify required parameter 'projectRoleId' is not null or undefined
        if (projectRoleId === null || projectRoleId === undefined) {
            throw new Error('Required parameter projectRoleId was null or undefined when calling deleteProjectRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してユーザの登録をプロジェクトから削除する。
     * @param projectId プロジェクトID
     * @param userId ユーザID
     */
    ProjectsApi.prototype.deleteProjectUser = function (projectId, userId) {
        var localVarPath = this.basePath + '/projects/{projectId}/users/{userId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteProjectUser.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling deleteProjectUser.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して資料を削除する。
     * @param projectId プロジェクトID
     * @param resFileId 資料ID
     */
    ProjectsApi.prototype.deleteResfile = function (projectId, resFileId) {
        var localVarPath = this.basePath + '/projects/{projectId}/resFiles/{resFileId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'resFileId' + '}', String(resFileId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteResfile.');
        }
        // verify required parameter 'resFileId' is not null or undefined
        if (resFileId === null || resFileId === undefined) {
            throw new Error('Required parameter resFileId was null or undefined when calling deleteResfile.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して帳票テンプレートを削除する。
     * @param projectId プロジェクトID
     * @param templateId 帳票テンプレートID
     */
    ProjectsApi.prototype.deleteTemplate = function (projectId, templateId) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates/{templateId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'templateId' + '}', String(templateId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteTemplate.');
        }
        // verify required parameter 'templateId' is not null or undefined
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling deleteTemplate.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してツリーを削除する。
     * @param projectId プロジェクトID
     * @param treeId ツリーID
     */
    ProjectsApi.prototype.deleteTree = function (projectId, treeId) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees/{treeId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'treeId' + '}', String(treeId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteTree.');
        }
        // verify required parameter 'treeId' is not null or undefined
        if (treeId === null || treeId === undefined) {
            throw new Error('Required parameter treeId was null or undefined when calling deleteTree.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してユーザ・所属グループを削除する。
     * @param projectId プロジェクトID
     * @param userOrganizationId ユーザ・所属グループID
     */
    ProjectsApi.prototype.deleteUserOrganization = function (projectId, userOrganizationId) {
        var localVarPath = this.basePath + '/projects/{projectId}/userOrganizations/{userOrganizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userOrganizationId' + '}', String(userOrganizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteUserOrganization.');
        }
        // verify required parameter 'userOrganizationId' is not null or undefined
        if (userOrganizationId === null || userOrganizationId === undefined) {
            throw new Error('Required parameter userOrganizationId was null or undefined when calling deleteUserOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工種を削除する。
     * @param projectId プロジェクトID
     * @param workId 工種ID
     */
    ProjectsApi.prototype.deleteWork = function (projectId, workId) {
        var localVarPath = this.basePath + '/projects/{projectId}/works/{workId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workId' + '}', String(workId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteWork.');
        }
        // verify required parameter 'workId' is not null or undefined
        if (workId === null || workId === undefined) {
            throw new Error('Required parameter workId was null or undefined when calling deleteWork.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工種グループを削除する。
     * @param projectId プロジェクトID
     * @param workGroupId 工種グループID
     */
    ProjectsApi.prototype.deleteWorkGroup = function (projectId, workGroupId) {
        var localVarPath = this.basePath + '/projects/{projectId}/workGroups/{workGroupId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workGroupId' + '}', String(workGroupId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteWorkGroup.');
        }
        // verify required parameter 'workGroupId' is not null or undefined
        if (workGroupId === null || workGroupId === undefined) {
            throw new Error('Required parameter workGroupId was null or undefined when calling deleteWorkGroup.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してデバイスを取得する。
     * @param projectId プロジェクトID
     * @param deviceId デバイスID
     */
    ProjectsApi.prototype.deviceById = function (projectId, deviceId) {
        var localVarPath = this.basePath + '/projects/{projectId}/devices/{deviceId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'deviceId' + '}', String(deviceId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deviceById.');
        }
        // verify required parameter 'deviceId' is not null or undefined
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling deviceById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してダウンロードを取得する。
     * @param projectId プロジェクトID
     * @param downloadId ダウンロードID
     */
    ProjectsApi.prototype.downloadById = function (projectId, downloadId) {
        var localVarPath = this.basePath + '/projects/{projectId}/downloads/{downloadId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'downloadId' + '}', String(downloadId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling downloadById.');
        }
        // verify required parameter 'downloadId' is not null or undefined
        if (downloadId === null || downloadId === undefined) {
            throw new Error('Required parameter downloadId was null or undefined when calling downloadById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して階を取得する。
     * @param projectId プロジェクトID
     * @param floorId 階ID
     */
    ProjectsApi.prototype.floorById = function (projectId, floorId) {
        var localVarPath = this.basePath + '/projects/{projectId}/floors/{floorId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'floorId' + '}', String(floorId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling floorById.');
        }
        // verify required parameter 'floorId' is not null or undefined
        if (floorId === null || floorId === undefined) {
            throw new Error('Required parameter floorId was null or undefined when calling floorById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工区一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getAreas = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/areas'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getAreas.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のデバイス一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getDevices = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/devices'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getDevices.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ダウンロード一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getDownloads = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/downloads'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getDownloads.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 写真を検索する
     * @param projectId プロジェクトID
     * @param criteria 写真検索情報
     */
    ProjectsApi.prototype.getFiles = function (projectId, criteria) {
        var localVarPath = this.basePath + '/projects/{projectId}/files'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFiles.');
        }
        // verify required parameter 'criteria' is not null or undefined
        if (criteria === null || criteria === undefined) {
            throw new Error('Required parameter criteria was null or undefined when calling getFiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: criteria,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクトの階一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getFloors = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/floors'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFloors.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクトの通り芯一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getGuides = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/guides'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getGuides.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のアイコンを取得する。
     * @param projectId プロジェクトID
     * @param nodeId ノードID
     * @param mapId マップID
     * @param zmin Z下限値（論理座標）
     * @param zmax Z上限値（論理座標）
     * @param inspectionId 検査ID
     * @param detail Resultなどの付随するデータを取得するかどうか(true, false)
     */
    ProjectsApi.prototype.getIconsForMap = function (projectId, nodeId, mapId, zmin, zmax, inspectionId, detail) {
        var localVarPath = this.basePath + '/projects/{projectId}/icons'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getIconsForMap.');
        }
        // verify required parameter 'nodeId' is not null or undefined
        if (nodeId === null || nodeId === undefined) {
            throw new Error('Required parameter nodeId was null or undefined when calling getIconsForMap.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling getIconsForMap.');
        }
        // verify required parameter 'zmin' is not null or undefined
        if (zmin === null || zmin === undefined) {
            throw new Error('Required parameter zmin was null or undefined when calling getIconsForMap.');
        }
        // verify required parameter 'zmax' is not null or undefined
        if (zmax === null || zmax === undefined) {
            throw new Error('Required parameter zmax was null or undefined when calling getIconsForMap.');
        }
        if (nodeId !== undefined) {
            queryParameters['nodeId'] = nodeId;
        }
        if (mapId !== undefined) {
            queryParameters['mapId'] = mapId;
        }
        if (zmin !== undefined) {
            queryParameters['zmin'] = zmin;
        }
        if (zmax !== undefined) {
            queryParameters['zmax'] = zmax;
        }
        if (inspectionId !== undefined) {
            queryParameters['inspectionId'] = inspectionId;
        }
        if (detail !== undefined) {
            queryParameters['detail'] = detail;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のアイコンを取得する。
     * @param projectId プロジェクトID
     * @param nodeId ノードID
     * @param mapId マップID
     * @param zmin Z下限値（論理座標）
     * @param zmax Z上限値（論理座標）
     * @param inspectionId 検査ID
     * @param detail Resultなどの付随するデータを取得するかどうか(true, false)
     */
    ProjectsApi.prototype.getIconsForProgress = function (projectId, nodeId, mapId, zmin, zmax, inspectionId, detail) {
        var localVarPath = this.basePath + '/projects/{projectId}/progressTable'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getIconsForProgress.');
        }
        // verify required parameter 'nodeId' is not null or undefined
        if (nodeId === null || nodeId === undefined) {
            throw new Error('Required parameter nodeId was null or undefined when calling getIconsForProgress.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling getIconsForProgress.');
        }
        // verify required parameter 'zmin' is not null or undefined
        if (zmin === null || zmin === undefined) {
            throw new Error('Required parameter zmin was null or undefined when calling getIconsForProgress.');
        }
        // verify required parameter 'zmax' is not null or undefined
        if (zmax === null || zmax === undefined) {
            throw new Error('Required parameter zmax was null or undefined when calling getIconsForProgress.');
        }
        if (nodeId !== undefined) {
            queryParameters['nodeId'] = nodeId;
        }
        if (mapId !== undefined) {
            queryParameters['mapId'] = mapId;
        }
        if (zmin !== undefined) {
            queryParameters['zmin'] = zmin;
        }
        if (zmax !== undefined) {
            queryParameters['zmax'] = zmax;
        }
        if (inspectionId !== undefined) {
            queryParameters['inspectionId'] = inspectionId;
        }
        if (detail !== undefined) {
            queryParameters['detail'] = detail;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内の検査ロール一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getInspectionRoles = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspectionRoles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getInspectionRoles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getInspections = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getInspections.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 場所プロパティマスター一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getLocationMasters = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/locationMasters'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getLocationMasters.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内の図面一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getMapfiles = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/mapFiles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getMapfiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のマップ一覧を取得する。
     * @param projectId プロジェクトID
     * @param kind マップ種類
     */
    ProjectsApi.prototype.getMaps = function (projectId, kind) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getMaps.');
        }
        if (kind !== undefined) {
            queryParameters['kind'] = kind;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 所属一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getOrganizations = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getOrganizations.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * null
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getProgress = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/progress'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getProgress.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のプロジェクトロール一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getProjectRoles = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/projectRoles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getProjectRoles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内のユーザ一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getProjectUsers = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/users'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getProjectUsers.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     プロジェクトを検索する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/projects   </dd>   <dt>parameters</dt>   <dd>     1. 一般ユーザがプロジェクト選択のために一覧を取得       queryパラメータとして「type=user」を指定する。       例. /v1/projects?type=user       誰でも実行が可能で、jwtで指定されたユーザがプロジェクト権限を持ちGSC_PROJECT.stateが1(検査中)であるプロジェクトの一覧を返す。     2. システム管理者がプロジェクト管理のために一覧を取得       queryパラメータとして「type=system」を指定する。さらに取得するプロジェクトの状態をstateで指定する。複数指定する場合はカンマで区切る。       例. /v1/projects?type=system&state=1,2,9       jwtで指定されたユーザがSYSTEM_CREATE_PROJECT,SYSTEM_EDIT_PROJECT,SYSTEM_DELETE_PROJECTのうち一つ以上の権限を持つ場合に実行が可能で、       GSC_PROJECT.stateがstateパラメータで指定された値であるプロジェクトの一覧を返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Projects'     ただし以下のプロパティのみ参照する。その他のプロパティへの値の設定は不要。     id, name, owner, state, created, update, archiving, completion, lastSynced, siteId, siteAddress, siteName, administratorId, adminEmail     プロジェクトがない場合は要素数0の配列を返す。   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param type 検索種類。
     * @param state プロジェクトの状態(GSC_PROJECT.state)。複数指定する場合はカンマで区切る。
     */
    ProjectsApi.prototype.getProjects = function (type, state) {
        var localVarPath = this.basePath + '/projects';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getProjects.');
        }
        if (type !== undefined) {
            queryParameters['type'] = type;
        }
        if (state !== undefined) {
            queryParameters['state'] = state;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクト内の資料一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getResfiles = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/resFiles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getResfiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票テンプレート一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getTemplates = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getTemplates.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ツリー一覧を取得する。
     * @param projectId プロジェクトID
     * @param recursive 下層のTREE_NODEも取得するかどうか(true, false)
     */
    ProjectsApi.prototype.getTrees = function (projectId, recursive) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getTrees.');
        }
        // verify required parameter 'recursive' is not null or undefined
        if (recursive === null || recursive === undefined) {
            throw new Error('Required parameter recursive was null or undefined when calling getTrees.');
        }
        if (recursive !== undefined) {
            queryParameters['recursive'] = recursive;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザ・所属グループ一覧を取得する。ユーザ、所属、検査のIDで絞り込むことが可能
     * @param projectId プロジェクトID
     * @param userId ユーザID
     * @param organizationId 所属ID
     * @param inspectionId 検査ID
     */
    ProjectsApi.prototype.getUserOrganizations = function (projectId, userId, organizationId, inspectionId) {
        var localVarPath = this.basePath + '/projects/{projectId}/userOrganizations'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getUserOrganizations.');
        }
        if (userId !== undefined) {
            queryParameters['userId'] = userId;
        }
        if (organizationId !== undefined) {
            queryParameters['organizationId'] = organizationId;
        }
        if (inspectionId !== undefined) {
            queryParameters['inspectionId'] = inspectionId;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種グループ一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getWorkGroups = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/workGroups'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getWorkGroups.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種一覧を取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.getWorks = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/works'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getWorks.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して通り芯を取得する。
     * @param projectId プロジェクトID
     * @param guideId 通り芯ID
     */
    ProjectsApi.prototype.guideById = function (projectId, guideId) {
        var localVarPath = this.basePath + '/projects/{projectId}/guides/{guideId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'guideId' + '}', String(guideId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling guideById.');
        }
        // verify required parameter 'guideId' is not null or undefined
        if (guideId === null || guideId === undefined) {
            throw new Error('Required parameter guideId was null or undefined when calling guideById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してアイコンを取得する。
     * @param projectId プロジェクトID
     * @param iconId アイコンID
     * @param detail Resultなどの付随するデータを取得するかどうか(true, false)
     */
    ProjectsApi.prototype.iconById = function (projectId, iconId, detail) {
        var localVarPath = this.basePath + '/projects/{projectId}/icons/{iconId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'iconId' + '}', String(iconId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling iconById.');
        }
        // verify required parameter 'iconId' is not null or undefined
        if (iconId === null || iconId === undefined) {
            throw new Error('Required parameter iconId was null or undefined when calling iconById.');
        }
        if (detail !== undefined) {
            queryParameters['detail'] = detail;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 非同期でデータをインポートする
     * @param projectId プロジェクトID
     * @param type データの種類
     * @param data JSONデータ
     */
    ProjectsApi.prototype.importAsync = function (projectId, type, data) {
        var localVarPath = this.basePath + '/projects/{projectId}/import/{type}/async'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'type' + '}', String(type));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling importAsync.');
        }
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling importAsync.');
        }
        // verify required parameter 'data' is not null or undefined
        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling importAsync.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: data,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して検査を取得する。
     * @param projectId プロジェクトID
     * @param inspectionId 検査ID
     */
    ProjectsApi.prototype.inspectionById = function (projectId, inspectionId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections/{inspectionId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionId' + '}', String(inspectionId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling inspectionById.');
        }
        // verify required parameter 'inspectionId' is not null or undefined
        if (inspectionId === null || inspectionId === undefined) {
            throw new Error('Required parameter inspectionId was null or undefined when calling inspectionById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して検査ロールを取得する。
     * @param projectId プロジェクトID
     * @param inspectionRoleId 検査ロールID
     */
    ProjectsApi.prototype.inspectionRoleById = function (projectId, inspectionRoleId) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspectionRoles/{inspectionRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionRoleId' + '}', String(inspectionRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling inspectionRoleById.');
        }
        // verify required parameter 'inspectionRoleId' is not null or undefined
        if (inspectionRoleId === null || inspectionRoleId === undefined) {
            throw new Error('Required parameter inspectionRoleId was null or undefined when calling inspectionRoleById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して場所プロパティマスターを取得する。
     * @param projectId プロジェクトID
     * @param locationMasterId 場所プロパティマスターID
     */
    ProjectsApi.prototype.locationMasterById = function (projectId, locationMasterId) {
        var localVarPath = this.basePath + '/projects/{projectId}/locationMasters/{locationMasterId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'locationMasterId' + '}', String(locationMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling locationMasterById.');
        }
        // verify required parameter 'locationMasterId' is not null or undefined
        if (locationMasterId === null || locationMasterId === undefined) {
            throw new Error('Required parameter locationMasterId was null or undefined when calling locationMasterById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してマップを取得する。
     * @param projectId プロジェクトID
     * @param mapId マップID
     */
    ProjectsApi.prototype.mapById = function (projectId, mapId) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps/{mapId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapId' + '}', String(mapId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling mapById.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling mapById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して図面を取得する。
     * @param projectId プロジェクトID
     * @param mapFileId 図面ID
     */
    ProjectsApi.prototype.mapfileById = function (projectId, mapFileId) {
        var localVarPath = this.basePath + '/projects/{projectId}/mapFiles/{mapFileId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapFileId' + '}', String(mapFileId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling mapfileById.');
        }
        // verify required parameter 'mapFileId' is not null or undefined
        if (mapFileId === null || mapFileId === undefined) {
            throw new Error('Required parameter mapFileId was null or undefined when calling mapfileById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して所属を取得する。
     * @param projectId プロジェクトID
     * @param organizationId 所属ID
     */
    ProjectsApi.prototype.organizationById = function (projectId, organizationId) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations/{organizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'organizationId' + '}', String(organizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling organizationById.');
        }
        // verify required parameter 'organizationId' is not null or undefined
        if (organizationId === null || organizationId === undefined) {
            throw new Error('Required parameter organizationId was null or undefined when calling organizationById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工区を作成する。
     * @param projectId プロジェクトID
     * @param area 工区情報
     */
    ProjectsApi.prototype.postArea = function (projectId, area) {
        var localVarPath = this.basePath + '/projects/{projectId}/areas'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postArea.');
        }
        // verify required parameter 'area' is not null or undefined
        if (area === null || area === undefined) {
            throw new Error('Required parameter area was null or undefined when calling postArea.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: area,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 写真ダウンロード物を生成する
     * @param projectId プロジェクトID
     * @param criteria 写真検索情報
     */
    ProjectsApi.prototype.postFiles = function (projectId, criteria) {
        var localVarPath = this.basePath + '/projects/{projectId}/files/async'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postFiles.');
        }
        // verify required parameter 'criteria' is not null or undefined
        if (criteria === null || criteria === undefined) {
            throw new Error('Required parameter criteria was null or undefined when calling postFiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: criteria,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 階を作成する。
     * @param projectId プロジェクトID
     * @param floor 階情報
     */
    ProjectsApi.prototype.postFloor = function (projectId, floor) {
        var localVarPath = this.basePath + '/projects/{projectId}/floors'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postFloor.');
        }
        // verify required parameter 'floor' is not null or undefined
        if (floor === null || floor === undefined) {
            throw new Error('Required parameter floor was null or undefined when calling postFloor.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: floor,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 通り芯を作成する。
     * @param projectId プロジェクトID
     * @param guide 通り芯情報
     */
    ProjectsApi.prototype.postGuide = function (projectId, guide) {
        var localVarPath = this.basePath + '/projects/{projectId}/guides'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postGuide.');
        }
        // verify required parameter 'guide' is not null or undefined
        if (guide === null || guide === undefined) {
            throw new Error('Required parameter guide was null or undefined when calling postGuide.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: guide,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査を作成する。
     * @param projectId プロジェクトID
     * @param inspection 検査情報
     */
    ProjectsApi.prototype.postInspection = function (projectId, inspection) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postInspection.');
        }
        // verify required parameter 'inspection' is not null or undefined
        if (inspection === null || inspection === undefined) {
            throw new Error('Required parameter inspection was null or undefined when calling postInspection.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspection,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査ロールを作成する。
     * @param projectId プロジェクトID
     * @param role 検査ロール
     */
    ProjectsApi.prototype.postInspectionRole = function (projectId, role) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspectionRoles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postInspectionRole.');
        }
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling postInspectionRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 場所プロパティマスターを作成する。
     * @param projectId プロジェクトID
     * @param locationMaster 場所プロパティマスター情報
     */
    ProjectsApi.prototype.postLocationMaster = function (projectId, locationMaster) {
        var localVarPath = this.basePath + '/projects/{projectId}/locationMasters'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postLocationMaster.');
        }
        // verify required parameter 'locationMaster' is not null or undefined
        if (locationMaster === null || locationMaster === undefined) {
            throw new Error('Required parameter locationMaster was null or undefined when calling postLocationMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: locationMaster,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * マップを作成する。
     * @param projectId プロジェクトID
     * @param map マップ
     */
    ProjectsApi.prototype.postMap = function (projectId, map) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postMap.');
        }
        // verify required parameter 'map' is not null or undefined
        if (map === null || map === undefined) {
            throw new Error('Required parameter map was null or undefined when calling postMap.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: map,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * マップをコピーする。
     * @param projectId プロジェクトID
     * @param mapFrom マップ
     */
     ProjectsApi.prototype.postMapFrom = function (projectId, mapFrom) {
      var localVarPath = this.basePath + '/projects/{projectId}/mapFrom'
          .replace('{' + 'projectId' + '}', String(projectId));
      var queryParameters = {};
      var headerParams = Object.assign({}, this.defaultHeaders);
      var formParams = {};
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
          throw new Error('Required parameter projectId was null or undefined when calling postMapFrom.');
      }
      // verify required parameter 'mapFrom' is not null or undefined
      if (mapFrom === null || mapFrom === undefined) {
          throw new Error('Required parameter mapFrom was null or undefined when calling postMapFrom.');
      }
      var useFormData = false;
      var requestOptions = {
          method: 'POST',
          qs: queryParameters,
          headers: headerParams,
          uri: localVarPath,
          useQuerystring: this._useQuerystring,
          json: true,
          body: mapFrom,
      };
      this.authentications.Bearer.applyToRequest(requestOptions);
      this.authentications.default.applyToRequest(requestOptions);
      if (Object.keys(formParams).length) {
          if (useFormData) {
              requestOptions.formData = formParams;
          }
          else {
              requestOptions.form = formParams;
          }
      }
      return new Promise(function (resolve, reject) {
          request(requestOptions, function (error, response, body) {
              if (error) {
                  reject(error);
              }
              else {
                  if (response.statusCode >= 200 && response.statusCode <= 299) {
                      resolve({ response: response, body: body });
                  }
                  else {
                      reject({ response: response, body: body });
                  }
              }
          });
      });
  };
  /**
     * <dl>   <dt>function</dt>   <dd>     図面を一括して登録する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/projects/1/mapFiles   </dd>   <dt>parameters</dt>   <dd>     図面を一括して登録する。     \"#/definitions/MapFile\"のprojectId、name、uploadIdに適切な値を設定し、その配列をRequestとして渡す。     その他のプロパティには値は設定しない。     jwtで指定されたユーザがPROJECT_CREATE_MAPFILE権限を持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/MapFiles'   </dd>   <dt>note</dt> </dl>
     * @param projectId プロジェクトID
     * @param mapfiles 図面情報の配列
     */
    ProjectsApi.prototype.postMapfiles = function (projectId, mapfiles) {
        var localVarPath = this.basePath + '/projects/{projectId}/mapFiles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postMapfiles.');
        }
        // verify required parameter 'mapfiles' is not null or undefined
        if (mapfiles === null || mapfiles === undefined) {
            throw new Error('Required parameter mapfiles was null or undefined when calling postMapfiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: mapfiles,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 所属を作成する。
     * @param projectId プロジェクトID
     * @param organization 所属情報
     */
    ProjectsApi.prototype.postOrganization = function (projectId, organization) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postOrganization.');
        }
        // verify required parameter 'organization' is not null or undefined
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling postOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: organization,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     プロジェクトを作成する。   </dd>   <dt>signature</dt>   <dd>     POST /v1/projects   </dd>   <dt>parameters</dt>   <dd>     システム管理者がプロジェクトを作成する。     bodyに記述されたjson(#/definitions/Project)の内容にしたがってプロジェクトを新規作成する。     jwtで指定されたユーザがSYSTEM_CREATE_PROJECT権限を持つ場合に実行が可能で、リクエスト中の以下の情報を用いてプロジェクトを作成する。     siteId, name, owner, completion, archiving, administratorId, adminEmail   </dd>   <dt>return</dt>   <dd>     '#/definitions/Project'     ただし以下のプロパティのみ参照する。その他のプロパティへの値の設定は不要。     id, name, owner, state, created, update, archiving, completion, siteId, siteAddress, siteName, administratorId, adminEmail   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param project プロジェクト情報
     */
    ProjectsApi.prototype.postProject = function (project) {
        var localVarPath = this.basePath + '/projects';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'project' is not null or undefined
        if (project === null || project === undefined) {
            throw new Error('Required parameter project was null or undefined when calling postProject.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: project,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクトロールを作成する。
     * @param projectId プロジェクトID
     * @param role プロジェクトロール
     */
    ProjectsApi.prototype.postProjectRole = function (projectId, role) {
        var localVarPath = this.basePath + '/projects/{projectId}/projectRoles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postProjectRole.');
        }
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling postProjectRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザをプロジェクトに関連付ける。
     * @param projectId プロジェクトID
     * @param user ユーザ
     */
    ProjectsApi.prototype.postProjectUser = function (projectId, user) {
        var localVarPath = this.basePath + '/projects/{projectId}/users'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postProjectUser.');
        }
        // verify required parameter 'user' is not null or undefined
        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling postProjectUser.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: user,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     資料を一括して登録する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/projects/1/resFiles   </dd>   <dt>parameters</dt>   <dd>     資料を一括して登録する。     \"#/definitions/ResFile\"のprojectId、name、uploadIdに適切な値を設定し、その配列をRequestとして渡す。     その他のプロパティには値は設定しない。     jwtで指定されたユーザがPROJECT_CREATE_MAPFILE権限を持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/ResFiles'   </dd>   <dt>note</dt> </dl>
     * @param projectId プロジェクトID
     * @param resfiles 資料情報の配列
     */
    ProjectsApi.prototype.postResfiles = function (projectId, resfiles) {
        var localVarPath = this.basePath + '/projects/{projectId}/resFiles'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postResfiles.');
        }
        // verify required parameter 'resfiles' is not null or undefined
        if (resfiles === null || resfiles === undefined) {
            throw new Error('Required parameter resfiles was null or undefined when calling postResfiles.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: resfiles,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票テンプレートを作成する。
     * @param projectId プロジェクトID
     * @param template 帳票テンプレート情報
     */
    ProjectsApi.prototype.postTemplate = function (projectId, template) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postTemplate.');
        }
        // verify required parameter 'template' is not null or undefined
        if (template === null || template === undefined) {
            throw new Error('Required parameter template was null or undefined when calling postTemplate.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: template,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ツリーを作成する。
     * @param projectId プロジェクトID
     * @param tree ツリー情報
     */
    ProjectsApi.prototype.postTree = function (projectId, tree) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postTree.');
        }
        // verify required parameter 'tree' is not null or undefined
        if (tree === null || tree === undefined) {
            throw new Error('Required parameter tree was null or undefined when calling postTree.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: tree,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };

    /**
     * ツリーを更新する。
     * @param projectId プロジェクトID
     * @param tree ツリー情報
     */
    ProjectsApi.prototype.putInspectable = function (projectId, tree) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postTree.');
        }
        // verify required parameter 'tree' is not null or undefined
        if (tree === null || tree === undefined) {
            throw new Error('Required parameter tree was null or undefined when calling postTree.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: tree,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザ・所属グループを作成する。
     * @param projectId プロジェクトID
     * @param userOrganization ユーザ・所属グループ情報
     */
    ProjectsApi.prototype.postUserOrganization = function (projectId, userOrganization) {
        var localVarPath = this.basePath + '/projects/{projectId}/userOrganizations'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postUserOrganization.');
        }
        // verify required parameter 'userOrganization' is not null or undefined
        if (userOrganization === null || userOrganization === undefined) {
            throw new Error('Required parameter userOrganization was null or undefined when calling postUserOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: userOrganization,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種を作成する。
     * @param projectId プロジェクトID
     * @param work 工種情報
     */
    ProjectsApi.prototype.postWork = function (projectId, work) {
        var localVarPath = this.basePath + '/projects/{projectId}/works'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postWork.');
        }
        // verify required parameter 'work' is not null or undefined
        if (work === null || work === undefined) {
            throw new Error('Required parameter work was null or undefined when calling postWork.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: work,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種グループを作成する。
     * @param projectId プロジェクトID
     * @param workGroup 工種グループ情報
     */
    ProjectsApi.prototype.postWorkGroup = function (projectId, workGroup) {
        var localVarPath = this.basePath + '/projects/{projectId}/workGroups'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling postWorkGroup.');
        }
        // verify required parameter 'workGroup' is not null or undefined
        if (workGroup === null || workGroup === undefined) {
            throw new Error('Required parameter workGroup was null or undefined when calling postWorkGroup.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: workGroup,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクトACLを取得する。
     * @param projectId プロジェクトID
     */
    ProjectsApi.prototype.projectAcl = function (projectId) {
        var localVarPath = this.basePath + '/projects/{projectId}/acl'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling projectAcl.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDと情報、詳細のレベルを指定してプロジェクト情報を取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/projects/{id}   </dd>   <dt>parameters</dt>   <dd>     1. プロジェクト一覧からプロジェクトを選択した時に選択プロジェクトの情報を表示するために取得。       queryパラメータとして「level=info」を指定する。       例. /v1/projects/1?level=info       IDを指定したプロジェクトへのアクセス権限を持つか、SYSTEM_CREATE_PROJECT,SYSTEM_EDIT_PROJECT,SYSTEM_DELETE_PROJECTのうち一つ以上の権限を持つ場合に実行が可能。       指定されたIDを持つプロジェクトについて以下のプロパティを設定して返す。       id, name, owner, state, created, update, archiving, completion, administratorId, adminEmail, lastSynced, siteId, siteAddress, siteName,        dataSize, inspections, numIcons, numMaps, numPhotos     2.プロジェクトを選択して 検査業務を行うために情報を取得。       queryパラメータとして「level=detail」を指定する。       例. /v1/projects/1?level=detail       IDを指定したプロジェクトへのアクセス権限を持つか、SYSTEM_CREATE_PROJECT,SYSTEM_EDIT_PROJECT,SYSTEM_DELETE_PROJECTのうち一つ以上の権限を持つ場合に実行が可能。       指定されたIDを持つプロジェクトについて全プロパティを設定して返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Project'   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param projectId プロジェクトID
     * @param level 取得する情報の詳細度(\&quot;info\&quot;, \&quot;detail\&quot;)
     */
    ProjectsApi.prototype.projectById = function (projectId, level) {
        var localVarPath = this.basePath + '/projects/{projectId}'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling projectById.');
        }
        // verify required parameter 'level' is not null or undefined
        if (level === null || level === undefined) {
            throw new Error('Required parameter level was null or undefined when calling projectById.');
        }
        if (level !== undefined) {
            queryParameters['level'] = level;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してプロジェクトロールを取得する。
     * @param projectId プロジェクトID
     * @param projectRoleId プロジェクトロールID
     */
    ProjectsApi.prototype.projectRoleById = function (projectId, projectRoleId) {
        var localVarPath = this.basePath + '/projects/{projectId}/projectRoles/{projectRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'projectRoleId' + '}', String(projectRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling projectRoleById.');
        }
        // verify required parameter 'projectRoleId' is not null or undefined
        if (projectRoleId === null || projectRoleId === undefined) {
            throw new Error('Required parameter projectRoleId was null or undefined when calling projectRoleById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してユーザを取得する。
     * @param projectId プロジェクトID
     * @param userId ユーザID
     */
    ProjectsApi.prototype.projectUserById = function (projectId, userId) {
        var localVarPath = this.basePath + '/projects/{projectId}/users/{userId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling projectUserById.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling projectUserById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工区を更新する。
     * @param projectId プロジェクトID
     * @param areaId 工区ID
     * @param area 工区
     */
    ProjectsApi.prototype.putArea = function (projectId, areaId, area) {
        var localVarPath = this.basePath + '/projects/{projectId}/areas/{areaId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'areaId' + '}', String(areaId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putArea.');
        }
        // verify required parameter 'areaId' is not null or undefined
        if (areaId === null || areaId === undefined) {
            throw new Error('Required parameter areaId was null or undefined when calling putArea.');
        }
        // verify required parameter 'area' is not null or undefined
        if (area === null || area === undefined) {
            throw new Error('Required parameter area was null or undefined when calling putArea.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: area,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 階を更新する。
     * @param projectId プロジェクトID
     * @param floorId 階ID
     * @param floor 階
     */
    ProjectsApi.prototype.putFloor = function (projectId, floorId, floor) {
        var localVarPath = this.basePath + '/projects/{projectId}/floors/{floorId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'floorId' + '}', String(floorId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putFloor.');
        }
        // verify required parameter 'floorId' is not null or undefined
        if (floorId === null || floorId === undefined) {
            throw new Error('Required parameter floorId was null or undefined when calling putFloor.');
        }
        // verify required parameter 'floor' is not null or undefined
        if (floor === null || floor === undefined) {
            throw new Error('Required parameter floor was null or undefined when calling putFloor.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: floor,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 通り芯を更新する。
     * @param projectId プロジェクトID
     * @param guideId 通り芯ID
     * @param guide 通り芯
     */
    ProjectsApi.prototype.putGuide = function (projectId, guideId, guide) {
        var localVarPath = this.basePath + '/projects/{projectId}/guides/{guideId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'guideId' + '}', String(guideId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putGuide.');
        }
        // verify required parameter 'guideId' is not null or undefined
        if (guideId === null || guideId === undefined) {
            throw new Error('Required parameter guideId was null or undefined when calling putGuide.');
        }
        // verify required parameter 'guide' is not null or undefined
        if (guide === null || guide === undefined) {
            throw new Error('Required parameter guide was null or undefined when calling putGuide.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: guide,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査を更新する。
     * @param projectId プロジェクトID
     * @param inspectionId 検査ID
     * @param master マスターデータを更新するかどうか
     * @param inspection 検査
     */
    ProjectsApi.prototype.putInspection = function (projectId, inspectionId, master, inspection) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections/{inspectionId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionId' + '}', String(inspectionId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putInspection.');
        }
        // verify required parameter 'inspectionId' is not null or undefined
        if (inspectionId === null || inspectionId === undefined) {
            throw new Error('Required parameter inspectionId was null or undefined when calling putInspection.');
        }
        // verify required parameter 'master' is not null or undefined
        if (master === null || master === undefined) {
            throw new Error('Required parameter master was null or undefined when calling putInspection.');
        }
        // verify required parameter 'inspection' is not null or undefined
        if (inspection === null || inspection === undefined) {
            throw new Error('Required parameter inspection was null or undefined when calling putInspection.');
        }
        if (master !== undefined) {
            queryParameters['master'] = master;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspection,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査ロールを更新する。
     * @param projectId プロジェクトID
     * @param inspectionRoleId 検査ロールID
     * @param role 検査ロール
     */
    ProjectsApi.prototype.putInspectionRole = function (projectId, inspectionRoleId, role) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspectionRoles/{inspectionRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'inspectionRoleId' + '}', String(inspectionRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putInspectionRole.');
        }
        // verify required parameter 'inspectionRoleId' is not null or undefined
        if (inspectionRoleId === null || inspectionRoleId === undefined) {
            throw new Error('Required parameter inspectionRoleId was null or undefined when calling putInspectionRole.');
        }
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling putInspectionRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 検査を一括更新する。
     * @param projectId プロジェクトID
     * @param inspections 検査リスト
     */
    ProjectsApi.prototype.putInspections = function (projectId, inspections) {
        var localVarPath = this.basePath + '/projects/{projectId}/inspections'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putInspections.');
        }
        // verify required parameter 'inspections' is not null or undefined
        if (inspections === null || inspections === undefined) {
            throw new Error('Required parameter inspections was null or undefined when calling putInspections.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspections,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 場所プロパティマスターを更新する。
     * @param projectId プロジェクトID
     * @param locationMasterId 場所プロパティマスターID
     * @param locationMaster 場所プロパティマスター
     */
    ProjectsApi.prototype.putLocationMaster = function (projectId, locationMasterId, locationMaster) {
        var localVarPath = this.basePath + '/projects/{projectId}/locationMasters/{locationMasterId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'locationMasterId' + '}', String(locationMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putLocationMaster.');
        }
        // verify required parameter 'locationMasterId' is not null or undefined
        if (locationMasterId === null || locationMasterId === undefined) {
            throw new Error('Required parameter locationMasterId was null or undefined when calling putLocationMaster.');
        }
        // verify required parameter 'locationMaster' is not null or undefined
        if (locationMaster === null || locationMaster === undefined) {
            throw new Error('Required parameter locationMaster was null or undefined when calling putLocationMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: locationMaster,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * マップを更新し、DZIを再生成する。
     * @param projectId プロジェクトID
     * @param mapId マップID
     * @param map マップ
     */
    ProjectsApi.prototype.putMap = function (projectId, mapId, map) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps/{mapId}/async'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapId' + '}', String(mapId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putMap.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling putMap.');
        }
        // verify required parameter 'map' is not null or undefined
        if (map === null || map === undefined) {
            throw new Error('Required parameter map was null or undefined when calling putMap.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: map,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * マップのプロパティを更新する。
     * @param projectId プロジェクトID
     * @param mapId マップID
     * @param map マップ
     */
    ProjectsApi.prototype.putMapProperty = function (projectId, mapId, map) {
        var localVarPath = this.basePath + '/projects/{projectId}/maps/{mapId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'mapId' + '}', String(mapId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putMapProperty.');
        }
        // verify required parameter 'mapId' is not null or undefined
        if (mapId === null || mapId === undefined) {
            throw new Error('Required parameter mapId was null or undefined when calling putMapProperty.');
        }
        // verify required parameter 'map' is not null or undefined
        if (map === null || map === undefined) {
            throw new Error('Required parameter map was null or undefined when calling putMapProperty.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: map,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 所属を更新する。
     * @param projectId プロジェクトID
     * @param organizationId 所属ID
     * @param organization 所属
     */
    ProjectsApi.prototype.putOrganization = function (projectId, organizationId, organization) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations/{organizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'organizationId' + '}', String(organizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putOrganization.');
        }
        // verify required parameter 'organizationId' is not null or undefined
        if (organizationId === null || organizationId === undefined) {
            throw new Error('Required parameter organizationId was null or undefined when calling putOrganization.');
        }
        // verify required parameter 'organization' is not null or undefined
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling putOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: organization,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 所属を一括更新する。
     * @param projectId プロジェクトID
     * @param organizations 所属リスト
     */
    ProjectsApi.prototype.putOrganizations = function (projectId, organizations) {
        var localVarPath = this.basePath + '/projects/{projectId}/organizations'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putOrganizations.');
        }
        // verify required parameter 'organizations' is not null or undefined
        if (organizations === null || organizations === undefined) {
            throw new Error('Required parameter organizations was null or undefined when calling putOrganizations.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: organizations,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     プロジェクトを更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/projects/{id}   </dd>   <dt>parameters</dt>   <dd>     システム管理者またはプロジェクト管理者がプロジェクト情報を更新する。     bodyに記述されたjson(#/definitions/Project)の内容にしたがってプロジェクトの情報を更新する。     IDを指定したプロジェクトのPROJECT_EDIT_DATAを持つか、SYSTEM_EDIT_PROJECTを持つ場合に実行が可能。     変更の対象となるプロパティは以下の通り。これらのプロパティには必ず値が設定されていることを前提とする。     siteId, name, owner, completion, archiving, state, administratorId, adminEmail     administratorIdが変更されている場合は、それまでの管理者はそのままその時点の権限でプロジェクトに残し、新たに指定されたadministratorIdのユーザをプロジェクト管理者とする。     その他のプロパティは無視しても良い。createdは更新しない。updatedは自動的に更新する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Project'     ただし以下のプロパティのみ参照する。その他のプロパティへの値の設定は不要。     siteId, name, owner, completion, archiving, state, administratorId, adminEmail   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param projectId プロジェクトID
     * @param project プロジェクト情報
     */
    ProjectsApi.prototype.putProject = function (projectId, project) {
        var localVarPath = this.basePath + '/projects/{projectId}'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putProject.');
        }
        // verify required parameter 'project' is not null or undefined
        if (project === null || project === undefined) {
            throw new Error('Required parameter project was null or undefined when calling putProject.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: project,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * プロジェクトロールを更新する。
     * @param projectId プロジェクトID
     * @param projectRoleId プロジェクトロールID
     * @param role プロジェクトロール
     */
    ProjectsApi.prototype.putProjectRole = function (projectId, projectRoleId, role) {
        var localVarPath = this.basePath + '/projects/{projectId}/projectRoles/{projectRoleId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'projectRoleId' + '}', String(projectRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putProjectRole.');
        }
        // verify required parameter 'projectRoleId' is not null or undefined
        if (projectRoleId === null || projectRoleId === undefined) {
            throw new Error('Required parameter projectRoleId was null or undefined when calling putProjectRole.');
        }
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling putProjectRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザを更新する。
     * @param projectId プロジェクトID
     * @param userId ユーザID
     * @param user ユーザ
     */
    ProjectsApi.prototype.putProjectUser = function (projectId, userId, user) {
        var localVarPath = this.basePath + '/projects/{projectId}/users/{userId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putProjectUser.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling putProjectUser.');
        }
        // verify required parameter 'user' is not null or undefined
        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling putProjectUser.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: user,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票テンプレートを更新する。
     * @param projectId プロジェクトID
     * @param templateId 帳票テンプレートID
     * @param template 帳票テンプレート情報
     */
    ProjectsApi.prototype.putTemplate = function (projectId, templateId, template) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates/{templateId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'templateId' + '}', String(templateId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putTemplate.');
        }
        // verify required parameter 'templateId' is not null or undefined
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling putTemplate.');
        }
        // verify required parameter 'template' is not null or undefined
        if (template === null || template === undefined) {
            throw new Error('Required parameter template was null or undefined when calling putTemplate.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: template,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 帳票テンプレートを一括更新する。
     * @param projectId プロジェクトID
     * @param templates 帳票テンプレートリスト
     */
    ProjectsApi.prototype.putTemplates = function (projectId, templates) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putTemplates.');
        }
        // verify required parameter 'templates' is not null or undefined
        if (templates === null || templates === undefined) {
            throw new Error('Required parameter templates was null or undefined when calling putTemplates.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: templates,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ツリーを更新する。
     * @param projectId プロジェクトID
     * @param treeId ツリーID
     * @param tree ツリー
     */
    ProjectsApi.prototype.putTree = function (projectId, treeId, tree) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees/{treeId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'treeId' + '}', String(treeId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putTree.');
        }
        // verify required parameter 'treeId' is not null or undefined
        if (treeId === null || treeId === undefined) {
            throw new Error('Required parameter treeId was null or undefined when calling putTree.');
        }
        // verify required parameter 'tree' is not null or undefined
        if (tree === null || tree === undefined) {
            throw new Error('Required parameter tree was null or undefined when calling putTree.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: tree,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ユーザ・所属グループを更新する。
     * @param projectId プロジェクトID
     * @param userOrganizationId ユーザ・所属グループID
     * @param userOrganization ユーザ・所属グループ
     */
    ProjectsApi.prototype.putUserOrganization = function (projectId, userOrganizationId, userOrganization) {
        var localVarPath = this.basePath + '/projects/{projectId}/userOrganizations/{userOrganizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userOrganizationId' + '}', String(userOrganizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putUserOrganization.');
        }
        // verify required parameter 'userOrganizationId' is not null or undefined
        if (userOrganizationId === null || userOrganizationId === undefined) {
            throw new Error('Required parameter userOrganizationId was null or undefined when calling putUserOrganization.');
        }
        // verify required parameter 'userOrganization' is not null or undefined
        if (userOrganization === null || userOrganization === undefined) {
            throw new Error('Required parameter userOrganization was null or undefined when calling putUserOrganization.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: userOrganization,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種を更新する。
     * @param projectId プロジェクトID
     * @param workId 工種ID
     * @param work 工種
     */
    ProjectsApi.prototype.putWork = function (projectId, workId, work) {
        var localVarPath = this.basePath + '/projects/{projectId}/works/{workId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workId' + '}', String(workId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putWork.');
        }
        // verify required parameter 'workId' is not null or undefined
        if (workId === null || workId === undefined) {
            throw new Error('Required parameter workId was null or undefined when calling putWork.');
        }
        // verify required parameter 'work' is not null or undefined
        if (work === null || work === undefined) {
            throw new Error('Required parameter work was null or undefined when calling putWork.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: work,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種グループを更新する。
     * @param projectId プロジェクトID
     * @param workGroupId 工種グループID
     * @param workGroup 工種グループ
     */
    ProjectsApi.prototype.putWorkGroup = function (projectId, workGroupId, workGroup) {
        var localVarPath = this.basePath + '/projects/{projectId}/workGroups/{workGroupId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workGroupId' + '}', String(workGroupId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putWorkGroup.');
        }
        // verify required parameter 'workGroupId' is not null or undefined
        if (workGroupId === null || workGroupId === undefined) {
            throw new Error('Required parameter workGroupId was null or undefined when calling putWorkGroup.');
        }
        // verify required parameter 'workGroup' is not null or undefined
        if (workGroup === null || workGroup === undefined) {
            throw new Error('Required parameter workGroup was null or undefined when calling putWorkGroup.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: workGroup,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 工種を一括更新する。
     * @param projectId プロジェクトID
     * @param works 工種リスト
     */
    ProjectsApi.prototype.putWorks = function (projectId, works) {
        var localVarPath = this.basePath + '/projects/{projectId}/works'
            .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling putWorks.');
        }
        // verify required parameter 'works' is not null or undefined
        if (works === null || works === undefined) {
            throw new Error('Required parameter works was null or undefined when calling putWorks.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: works,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDで指定されるユーザのパスワードをリセットし、メールを送信する。
     * @param projectId プロジェクトID
     * @param userId ユーザID
     */
    ProjectsApi.prototype.resetPassword = function (projectId, userId) {
        var localVarPath = this.basePath + '/projects/{projectId}/users/{userId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling resetPassword.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling resetPassword.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して資料を取得する。
     * @param projectId プロジェクトID
     * @param resFileId 資料ID
     */
    ProjectsApi.prototype.resfileById = function (projectId, resFileId) {
        var localVarPath = this.basePath + '/projects/{projectId}/resFiles/{resFileId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'resFileId' + '}', String(resFileId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling resfileById.');
        }
        // verify required parameter 'resFileId' is not null or undefined
        if (resFileId === null || resFileId === undefined) {
            throw new Error('Required parameter resFileId was null or undefined when calling resfileById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して帳票テンプレートを取得する。
     * @param projectId プロジェクトID
     * @param templateId 帳票テンプレートID
     */
    ProjectsApi.prototype.templateById = function (projectId, templateId) {
        var localVarPath = this.basePath + '/projects/{projectId}/templates/{templateId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'templateId' + '}', String(templateId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling templateById.');
        }
        // verify required parameter 'templateId' is not null or undefined
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling templateById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してツリーを取得する。
     * @param projectId プロジェクトID
     * @param treeId ツリーID
     * @param recursive 下層のTREE_NODEも取得するかどうか(true, false)
     */
    ProjectsApi.prototype.treeById = function (projectId, treeId, recursive) {
        var localVarPath = this.basePath + '/projects/{projectId}/trees/{treeId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'treeId' + '}', String(treeId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling treeById.');
        }
        // verify required parameter 'treeId' is not null or undefined
        if (treeId === null || treeId === undefined) {
            throw new Error('Required parameter treeId was null or undefined when calling treeById.');
        }
        // verify required parameter 'recursive' is not null or undefined
        if (recursive === null || recursive === undefined) {
            throw new Error('Required parameter recursive was null or undefined when calling treeById.');
        }
        if (recursive !== undefined) {
            queryParameters['recursive'] = recursive;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * アイコンを更新する。
     * @param projectId プロジェクトID
     * @param iconId アイコンID
     * @param icon アイコン
     */
    ProjectsApi.prototype.updateIcon = function (projectId, iconId, icon) {
        var localVarPath = this.basePath + '/projects/{projectId}/icons/{iconId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'iconId' + '}', String(iconId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateIcon.');
        }
        // verify required parameter 'iconId' is not null or undefined
        if (iconId === null || iconId === undefined) {
            throw new Error('Required parameter iconId was null or undefined when calling updateIcon.');
        }
        // verify required parameter 'icon' is not null or undefined
        if (icon === null || icon === undefined) {
            throw new Error('Required parameter icon was null or undefined when calling updateIcon.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: icon,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してユーザ・所属グループグループを取得する。
     * @param projectId プロジェクトID
     * @param userOrganizationId ユーザ・所属グループID
     */
    ProjectsApi.prototype.userOrganizationById = function (projectId, userOrganizationId) {
        var localVarPath = this.basePath + '/projects/{projectId}/userOrganizations/{userOrganizationId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'userOrganizationId' + '}', String(userOrganizationId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling userOrganizationById.');
        }
        // verify required parameter 'userOrganizationId' is not null or undefined
        if (userOrganizationId === null || userOrganizationId === undefined) {
            throw new Error('Required parameter userOrganizationId was null or undefined when calling userOrganizationById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工種を取得する。
     * @param projectId プロジェクトID
     * @param workId 工種ID
     */
    ProjectsApi.prototype.workById = function (projectId, workId) {
        var localVarPath = this.basePath + '/projects/{projectId}/works/{workId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workId' + '}', String(workId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling workById.');
        }
        // verify required parameter 'workId' is not null or undefined
        if (workId === null || workId === undefined) {
            throw new Error('Required parameter workId was null or undefined when calling workById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定して工種グループを取得する。
     * @param projectId プロジェクトID
     * @param workGroupId 工種グループID
     */
    ProjectsApi.prototype.workGroupById = function (projectId, workGroupId) {
        var localVarPath = this.basePath + '/projects/{projectId}/workGroups/{workGroupId}'
            .replace('{' + 'projectId' + '}', String(projectId))
            .replace('{' + 'workGroupId' + '}', String(workGroupId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling workGroupById.');
        }
        // verify required parameter 'workGroupId' is not null or undefined
        if (workGroupId === null || workGroupId === undefined) {
            throw new Error('Required parameter workGroupId was null or undefined when calling workGroupById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
    * リストアイコンを作成します。
    * @param projectId プロジェクトID
    * @param icon アイコン
    */
     ProjectsApi.prototype.createListIcon = function (projectId, icon) {
      var localVarPath = this.basePath + '/projects/{projectId}/listicons'
      .replace('{' + 'projectId' + '}', String(projectId));
      var queryParameters = {};
      var headerParams = Object.assign({}, this.defaultHeaders);
      var formParams = {};
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
      throw new Error('Required parameter projectId was null or undefined when calling createListIcon.');
      }
      // verify required parameter 'icon' is not null or undefined
      if (icon === null || icon === undefined) {
      throw new Error('Required parameter icon was null or undefined when calling createListIcon.');
      }
      var useFormData = false;
      var requestOptions = {
      method: 'POST',
      qs: queryParameters,
      headers: headerParams,
      uri: localVarPath,
      useQuerystring: this._useQuerystring,
      json: true,
      body: icon,
      };
      this.authentications.Bearer.applyToRequest(requestOptions);
      this.authentications.default.applyToRequest(requestOptions);
      if (Object.keys(formParams).length) {
      if (useFormData) {
          requestOptions.formData = formParams;
      }
      else {
          requestOptions.form = formParams;
      }
      }
      
      return new Promise(function (resolve, reject) {
      request(requestOptions, function (error, response, body) {
          if (error) {
          reject(error);
          }
          else {
          if (response.statusCode >= 200 && response.statusCode <= 299) {
              resolve({ response: response, body: body });
          }
          else {
              reject({ response: response, body: body });
          }
          }
      });
      });
    };
    /**
     * 
     * @param {*} projectId 
     * @param {*} iconId 
     * @param {*} detail 
     */
    ProjectsApi.prototype.getIconDetailForMap = function (projectId, iconId, detail = false) {
      var localVarPath = this.basePath + '/projects/{projectId}/icons/{iconId}'
          .replace('{' + 'projectId' + '}', String(projectId))
          .replace('{' + 'iconId' + '}', String(iconId));
      var queryParameters = {};
      var headerParams = Object.assign({}, this.defaultHeaders);
      var formParams = {};
      // verify required parameter 'projectId' is not null or undefined
      if (projectId === null || projectId === undefined) {
          throw new Error('Required parameter projectId was null or undefined when calling getIconDetailForMap.');
      }
      // verify required parameter 'iconId' is not null or undefined
      if (iconId === null || iconId === undefined) {
          throw new Error('Required parameter iconId was null or undefined when calling getIconDetailForMap.');
      }
      if (iconId !== undefined) {
          queryParameters['iconId'] = iconId;
      }
      if (detail !== undefined) {
          queryParameters['detail'] = detail;
      }
      var useFormData = false;
      var requestOptions = {
          method: 'GET',
          qs: queryParameters,
          headers: headerParams,
          uri: localVarPath,
          useQuerystring: this._useQuerystring,
          json: true,
      };
      this.authentications.Bearer.applyToRequest(requestOptions);
      this.authentications.default.applyToRequest(requestOptions);
      if (Object.keys(formParams).length) {
          if (useFormData) {
              requestOptions.formData = formParams;
          }
          else {
              requestOptions.form = formParams;
          }
      }
      return new Promise(function (resolve, reject) {
          request(requestOptions, function (error, response, body) {
              if (error) {
                  reject(error);
              }
              else {
                  if (response.statusCode >= 200 && response.statusCode <= 299) {
                      resolve({ response: response, body: body });
                  }
                  else {
                      reject({ response: response, body: body });
                  }
              }
          });
      });
    };
    /**
    * IDを指定して工種グループを取得する。
    * @param projectId プロジェクトID
    * @param workGroupId 工種グループID
    */
    ProjectsApi.prototype.getUpperLowerIcons = function (projectId, nearestCrossSection) {
        var localVarPath = this.basePath + '/projects/{projectId}/upperLowerIcons'
        .replace('{' + 'projectId' + '}', String(projectId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'projectId' is not null or undefined
        if (projectId === null || projectId === undefined) {
        throw new Error('Required parameter projectId was null or undefined when calling getMaps.');
        }
        if (nearestCrossSection !== undefined) {
        queryParameters = nearestCrossSection;
        }
        var useFormData = false;
        var requestOptions = {
        method: 'GET',
        qs: queryParameters,
        headers: headerParams,
        uri: localVarPath,
        useQuerystring: this._useQuerystring,
        json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
        if (useFormData) {
            requestOptions.formData = formParams;
        }
        else {
            requestOptions.form = formParams;
        }
        }
        return new Promise(function (resolve, reject) {
        request(requestOptions, function (error, response, body) {
            if (error) {
            reject(error);
            }
            else {
            if (response.statusCode >= 200 && response.statusCode <= 299) {
                resolve({ response: response, body: body });
            }
            else {
                reject({ response: response, body: body });
            }
            }
        });
        });
    };    
    return ProjectsApi;
}());
exports.ProjectsApi = ProjectsApi;
var SystemApiApiKeys;
(function (SystemApiApiKeys) {
    SystemApiApiKeys[SystemApiApiKeys["Bearer"] = 0] = "Bearer";
})(SystemApiApiKeys = exports.SystemApiApiKeys || (exports.SystemApiApiKeys = {}));
var SystemApi = /** @class */ (function () {
    function SystemApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(SystemApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SystemApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    SystemApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    SystemApi.prototype.setApiKey = function (key, value) {
        this.authentications[SystemApiApiKeys[key]].apiKey = value;
    };
    /**
     * GSC_ICONの検査結果キャッシュを生成・更新する。
     */
    SystemApi.prototype.createCache = function () {
        var localVarPath = this.basePath + '/dangerzone/createCache';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ヘルプを削除する。   </dd>   <dt>signature</dt>   <dd>     DELETE /v1/help/{helpId}   </dd>   <dt>parameters</dt>   <dd>     システム管理者がヘルプを削除する。     pathで指定されたIDのヘルプを削除する。     SYSTEM_HELP権限を持つ場合に実行が可能。   </dd> </dl>
     * @param helpId ヘルプID
     */
    SystemApi.prototype.deleteHelp = function (helpId) {
        var localVarPath = this.basePath + '/help/{helpId}'
            .replace('{' + 'helpId' + '}', String(helpId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'helpId' is not null or undefined
        if (helpId === null || helpId === undefined) {
            throw new Error('Required parameter helpId was null or undefined when calling deleteHelp.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     検査マスターを削除する。   </dd>   <dt>signature</dt>   <dd>     DELETE /v1/inspectionMasters/{inspectionMasterId}   </dd>   <dt>parameters</dt>   <dd>     システム管理者が検査マスターを削除する。     pathで指定されたIDの検査マスターを削除する。     SYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能。   </dd> </dl>
     * @param inspectionMasterId 検査マスターID
     */
    SystemApi.prototype.deleteInspectionMaster = function (inspectionMasterId) {
        var localVarPath = this.basePath + '/inspectionMasters/{inspectionMasterId}'
            .replace('{' + 'inspectionMasterId' + '}', String(inspectionMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionMasterId' is not null or undefined
        if (inspectionMasterId === null || inspectionMasterId === undefined) {
            throw new Error('Required parameter inspectionMasterId was null or undefined when calling deleteInspectionMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * キーを指定して設定を削除する。
     * @param preferenceKey 設定キー
     */
    SystemApi.prototype.deletePreference = function (preferenceKey) {
        var localVarPath = this.basePath + '/preferences/{preferenceKey}'
            .replace('{' + 'preferenceKey' + '}', String(preferenceKey));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'preferenceKey' is not null or undefined
        if (preferenceKey === null || preferenceKey === undefined) {
            throw new Error('Required parameter preferenceKey was null or undefined when calling deletePreference.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してシステムロールを削除する。
     * @param systemRoleId システムロールID
     */
    SystemApi.prototype.deleteSystemRole = function (systemRoleId) {
        var localVarPath = this.basePath + '/systemRoles/{systemRoleId}'
            .replace('{' + 'systemRoleId' + '}', String(systemRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'systemRoleId' is not null or undefined
        if (systemRoleId === null || systemRoleId === undefined) {
            throw new Error('Required parameter systemRoleId was null or undefined when calling deleteSystemRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDを指定してユーザを削除する。   </dd>   <dt>signature</dt>   <dd>     DELETE /v1/users/{id}   </dd>   <dt>parameters</dt>   <dd>     システム管理者がユーザを削除する。     pathで指定されたIDのユーザを削除する。     SYSTEM_USERを持つ場合に実行が可能。     参照されているデータがある場合は400エラーとなる。（SQL DELETE文実行時にエラーが出たら400を返すで良い）   </dd> </dl>
     * @param userId ユーザID
     */
    SystemApi.prototype.deleteUser = function (userId) {
        var localVarPath = this.basePath + '/users/{userId}'
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling deleteUser.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'DELETE',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ヘルプ一覧を取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/help     複数形にならないことに注意。helpには不加算名詞なので、パスだけはhelpにしました。   </dd>   <dt>parameters</dt>   <dd>       ヘルプ一覧を取得する。JWTで認証されたすべてのユーザが実行可能。       1. システム管理者がヘルプ管理のために一覧を取得する場合。       2. ログインユーザのヘルプメニューに必要なヘルプを表示するために取得する場合。       queryパラメータとして「inspectionModelId」が指定された場合は該当する検査モデルのヘルプのみを取得する。       例. /v1/help?inspectionModelId=1       特例として「inspectionModelId=0」が指定された場合は該当する共通基盤のヘルプのみを取得する。       例. /v1/help?inspectionModelId=0   </dd>   <dt>return</dt>   <dd>     '#/definitions/Helps'     ヘルプがない場合は要素数0の配列を返す。   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param inspectionModelId 検索モデルID
     */
    SystemApi.prototype.getHelps = function (inspectionModelId) {
        var localVarPath = this.basePath + '/help';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        if (inspectionModelId !== undefined) {
            queryParameters['inspectionModelId'] = inspectionModelId;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     検査マスター一覧を取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/inspectionMasters   </dd>   <dt>parameters</dt>   <dd>       queryパラメータとして「inspectionModelId」が指定された場合は該当する検査モデルのマスターデータのみを取得する。       例. /v1/inspectionMasters?inspectionModelId=1       jwtで指定されたユーザがSYSTEM_INSPECTION_MODELの権限を持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionMasters'     ただし以下のプロパティのみ参照する。その他のプロパティへの値の設定は不要。     id, name, owner, state, created, update, archiving, completion, lastSynced, siteId, siteAddress, siteName, administratorId, adminEmail     プロジェクトがない場合は要素数0の配列を返す。   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param inspectionModelId 検索モデルID
     */
    SystemApi.prototype.getInspectionMasters = function (inspectionModelId) {
        var localVarPath = this.basePath + '/inspectionMasters';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        if (inspectionModelId !== undefined) {
            queryParameters['inspectionModelId'] = inspectionModelId;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>      検査モデル一覧を取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/inspectionModels   </dd>   <dt>parameters</dt>   <dd>     システム管理者がシステム管理・検査管理のために一覧を取得する。     jwtで指定されたユーザがSYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能で、     GSC_INSPECTION_MODELの一覧を返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionModels'   </dd> </dl>
     */
    SystemApi.prototype.getInspectionModels = function () {
        var localVarPath = this.basePath + '/inspectionModels';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     設定一覧を取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/preferences   </dd>   <dt>parameters</dt>   <dd>     システム管理者によるメール等の設定一覧を表示するために一覧を取得     常にすべての設定情報（GSC_PREFERENCE)を取得する。     jwtで指定されたユーザがSYSTEM_MAIL,SYSTEM_SETTINGのうち一つ以上の権限を持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Preferences'     設定がない場合は要素数0の配列を返す。   </dd>   <dt>note</dt> </dl>
     */
    SystemApi.prototype.getPreferences = function () {
        var localVarPath = this.basePath + '/preferences';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * システムロール一覧を取得する。
     */
    SystemApi.prototype.getSystemRoles = function () {
        var localVarPath = this.basePath + '/systemRoles';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ユーザを検索する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/users   </dd>   <dt>parameters</dt>   <dd>     システム管理者がユーザ管理やプロジェクト作成時にユーザを検索する。     queryパラメータとしてメールアドレスをemailで指定することができる。     emailに指定された単語を一部に含むユーザの一覧を返す。指定されない場合は全ユーザを返す。     例. /v1/users?email=user@company.co.jp メールアドレスとして「user@company.co.jp」を持つユーザを検索     例. /v1/users すべてのユーザを検索     jwtで指定されたユーザがSYSTEM_USER,SYSTEM_CREATE_PROJECT,SYSTEM_EDIT_PROJECTのうち一つ以上の権限を持つ場合に実行が可能。     GSC_USERを検索し、該当ユーザが存在するかどうかを確認する。     大林組イントラ連携が有効である場合、GSC_USERに該当ユーザがしない場合でかつメールアドレスのドメインが大林組である場合は、さらにイントラ連携APIを用いて大林組にメールアドレスが存在するかどうかを確認する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Users'     ユーザがない場合は要素数0の配列を返す。   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param email メールアドレス
     */
    SystemApi.prototype.getUsers = function (email) {
        var localVarPath = this.basePath + '/users';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        if (email !== undefined) {
            queryParameters['email'] = email;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDを指定してヘルプを取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/help/{helpId}     複数形にならないことに注意。helpには不加算名詞なので、パスだけはhelpにしました。   </dd>   <dt>parameters</dt>   <dd>     pathパラメータで指定されたIDを持つヘルプを取得する。     例. /v1/help/1     SYSTEM_HELP権限を持つ場合に実行が可能。     指定されたIDを持つヘルプについてid, inspectionModelId, name, description, url, created, updatedを設定して返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Help'   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param helpId ヘルプID
     */
    SystemApi.prototype.helpById = function (helpId) {
        var localVarPath = this.basePath + '/help/{helpId}'
            .replace('{' + 'helpId' + '}', String(helpId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'helpId' is not null or undefined
        if (helpId === null || helpId === undefined) {
            throw new Error('Required parameter helpId was null or undefined when calling helpById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDを指定して検査マスターを取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/inspectionMasters/{inspectionMasterId}   </dd>   <dt>parameters</dt>   <dd>     pathパラメータで指定されたIDを持つ検査マスターを取得する。     例. /v1/inspectionMasters/1     SYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能。     指定されたIDを持つ検査マスターについて全プロパティを設定して返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionMaster'   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param inspectionMasterId 検査マスターID
     */
    SystemApi.prototype.inspectionMasterById = function (inspectionMasterId) {
        var localVarPath = this.basePath + '/inspectionMasters/{inspectionMasterId}'
            .replace('{' + 'inspectionMasterId' + '}', String(inspectionMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionMasterId' is not null or undefined
        if (inspectionMasterId === null || inspectionMasterId === undefined) {
            throw new Error('Required parameter inspectionMasterId was null or undefined when calling inspectionMasterById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDを指定して検査モデルを取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/inspectionModels/{inspectionModelId}   </dd>   <dt>parameters</dt>   <dd>     pathパラメータで指定されたIDを持つ検査モデルを取得する。     例. /v1/inspectionModels/1     SYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能。     指定されたIDを持つ検査モデルについて全プロパティを設定して返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionModel'   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param inspectionModelId 検査モデルID
     */
    SystemApi.prototype.inspectionModelById = function (inspectionModelId) {
        var localVarPath = this.basePath + '/inspectionModels/{inspectionModelId}'
            .replace('{' + 'inspectionModelId' + '}', String(inspectionModelId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionModelId' is not null or undefined
        if (inspectionModelId === null || inspectionModelId === undefined) {
            throw new Error('Required parameter inspectionModelId was null or undefined when calling inspectionModelById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ヘルプを作成する。   </dd>   <dt>signature</dt>   <dd>     POST /v1/help   </dd>   <dt>parameters</dt>   <dd>     システム管理者がヘルプを作成する。     bodyに記述されたjson(#/definitions/Help)の内容にしたがってヘルプを新規作成する。     ファイルはあらかじめupload apiを用いてストレージにアップロードされる。その時に発行されたuploadIdを参照することで、ストレージにアップロードされたファイルを知ることができる。     jwtで指定されたユーザがSYSTEM_HELP権限を持つ場合に実行が可能で、リクエスト中の以下の情報を用いてヘルプを作成する。     inspectionModelId, name, description, uploadId     created, updatedはサーバで決定する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Help'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param help ヘルプ情報
     */
    SystemApi.prototype.postHelp = function (help) {
        var localVarPath = this.basePath + '/help';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'help' is not null or undefined
        if (help === null || help === undefined) {
            throw new Error('Required parameter help was null or undefined when calling postHelp.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: help,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     検査マスターを作成する。   </dd>   <dt>signature</dt>   <dd>     POST /v1/inspectionMasters   </dd>   <dt>parameters</dt>   <dd>     システム管理者が検査マスターを作成する。     bodyに記述されたjson(#/definitions/InspectionMaster)の内容にしたがって検査マスターを新規作成する。     jwtで指定されたユーザがSYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能で、リクエスト中の以下の情報を用いて検査マスターを作成する。     inspectionModelId, name, master     created, updatedはサーバで決定する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionMaster'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param inspectionMaster 検査マスター情報
     */
    SystemApi.prototype.postInspectionMaster = function (inspectionMaster) {
        var localVarPath = this.basePath + '/inspectionMasters';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionMaster' is not null or undefined
        if (inspectionMaster === null || inspectionMaster === undefined) {
            throw new Error('Required parameter inspectionMaster was null or undefined when calling postInspectionMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspectionMaster,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 設定を作成する。（実装の必要はなし）
     * @param preference 設定情報
     */
    SystemApi.prototype.postPreference = function (preference) {
        var localVarPath = this.basePath + '/preferences';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'preference' is not null or undefined
        if (preference === null || preference === undefined) {
            throw new Error('Required parameter preference was null or undefined when calling postPreference.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: preference,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * システムロールを作成する。
     * @param role システムロール
     */
    SystemApi.prototype.postSystemRole = function (role) {
        var localVarPath = this.basePath + '/systemRoles';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling postSystemRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * キーを指定して設定を取得する。
     * @param preferenceKey 設定キー
     */
    SystemApi.prototype.preferenceByKey = function (preferenceKey) {
        var localVarPath = this.basePath + '/preferences/{preferenceKey}'
            .replace('{' + 'preferenceKey' + '}', String(preferenceKey));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'preferenceKey' is not null or undefined
        if (preferenceKey === null || preferenceKey === undefined) {
            throw new Error('Required parameter preferenceKey was null or undefined when calling preferenceByKey.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ヘルプを更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/help/{helpId}   </dd>   <dt>parameters</dt>   <dd>     システム管理者がヘルプを更新する。     bodyに記述されたjson(#/definitions/Help)の内容にしたがってヘルプの情報を更新する。     SYSTEM_HELP権限を持つ場合に実行が可能。     変更の対象となるプロパティは以下の通り。これらのプロパティには必ず値が設定されていることを前提とする。     name, description     uploadIdがnullでない場合はコンテンツ（ファイル）を更新（入れ替える）する。     createdは更新しない。updatedは自動的に更新する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Help'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param helpId ヘルプID
     * @param help ヘルプ
     */
    SystemApi.prototype.putHelp = function (helpId, help) {
        var localVarPath = this.basePath + '/help/{helpId}'
            .replace('{' + 'helpId' + '}', String(helpId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'helpId' is not null or undefined
        if (helpId === null || helpId === undefined) {
            throw new Error('Required parameter helpId was null or undefined when calling putHelp.');
        }
        // verify required parameter 'help' is not null or undefined
        if (help === null || help === undefined) {
            throw new Error('Required parameter help was null or undefined when calling putHelp.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: help,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     検査マスターを更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/inspectionMasters/{inspectionMasterId}   </dd>   <dt>parameters</dt>   <dd>     システム管理者が検査マスターを更新する。     bodyに記述されたjson(#/definitions/InspectionMaster)の内容にしたがって検査マスターの情報を更新する。     SYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能。     変更の対象となるプロパティは以下の通り。これらのプロパティには必ず値が設定されていることを前提とする。     name, master, inspectionModelId     createdは更新しない。updatedは自動的に更新する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionMaster'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param inspectionMasterId 検査マスターID
     * @param inspectionMaster 検査マスター
     */
    SystemApi.prototype.putInspectionMaster = function (inspectionMasterId, inspectionMaster) {
        var localVarPath = this.basePath + '/inspectionMasters/{inspectionMasterId}'
            .replace('{' + 'inspectionMasterId' + '}', String(inspectionMasterId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionMasterId' is not null or undefined
        if (inspectionMasterId === null || inspectionMasterId === undefined) {
            throw new Error('Required parameter inspectionMasterId was null or undefined when calling putInspectionMaster.');
        }
        // verify required parameter 'inspectionMaster' is not null or undefined
        if (inspectionMaster === null || inspectionMaster === undefined) {
            throw new Error('Required parameter inspectionMaster was null or undefined when calling putInspectionMaster.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspectionMaster,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     検査モデルを更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/inspectionModels/{inspectionModelId}   </dd>   <dt>parameters</dt>   <dd>     システム管理者が検査モデルを更新する。     bodyに記述されたjson(#/definitions/InspectionModel)の内容にしたがって検査モデルの情報を更新する。     SYSTEM_INSPECTION_MODEL権限を持つ場合に実行が可能。     変更の対象となるプロパティは以下の通り。これらのプロパティには必ず値が設定されていることを前提とする。     inspectionModelNumber, inspectionModelKey, name     createdは更新しない。updatedは自動的に更新する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/InspectionModel'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param inspectionModelId 検査モデルID
     * @param inspectionModel 検査モデル
     */
    SystemApi.prototype.putInspectionModel = function (inspectionModelId, inspectionModel) {
        var localVarPath = this.basePath + '/inspectionModels/{inspectionModelId}'
            .replace('{' + 'inspectionModelId' + '}', String(inspectionModelId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'inspectionModelId' is not null or undefined
        if (inspectionModelId === null || inspectionModelId === undefined) {
            throw new Error('Required parameter inspectionModelId was null or undefined when calling putInspectionModel.');
        }
        // verify required parameter 'inspectionModel' is not null or undefined
        if (inspectionModel === null || inspectionModel === undefined) {
            throw new Error('Required parameter inspectionModel was null or undefined when calling putInspectionModel.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: inspectionModel,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * 設定を更新する。
     * @param preferenceKey 設定キー
     * @param preference 設定情報
     */
    SystemApi.prototype.putPreference = function (preferenceKey, preference) {
        var localVarPath = this.basePath + '/preferences/{preferenceKey}'
            .replace('{' + 'preferenceKey' + '}', String(preferenceKey));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'preferenceKey' is not null or undefined
        if (preferenceKey === null || preferenceKey === undefined) {
            throw new Error('Required parameter preferenceKey was null or undefined when calling putPreference.');
        }
        // verify required parameter 'preference' is not null or undefined
        if (preference === null || preference === undefined) {
            throw new Error('Required parameter preference was null or undefined when calling putPreference.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: preference,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     設定を一括して更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/preferences   </dd>   <dt>parameters</dt>   <dd>     設定を一括して更新する。     jwtで指定されたユーザがSYSTEM_MAIL,SYSTEM_SETTINGのうち一つ以上の権限を持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/Preferences'   </dd>   <dt>note</dt> </dl>
     * @param preferences 設定情報の配列
     */
    SystemApi.prototype.putPreferences = function (preferences) {
        var localVarPath = this.basePath + '/preferences';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'preferences' is not null or undefined
        if (preferences === null || preferences === undefined) {
            throw new Error('Required parameter preferences was null or undefined when calling putPreferences.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: preferences,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * システムロールを更新する。
     * @param systemRoleId システムロールID
     * @param role システムロール
     */
    SystemApi.prototype.putSystemRole = function (systemRoleId, role) {
        var localVarPath = this.basePath + '/systemRoles/{systemRoleId}'
            .replace('{' + 'systemRoleId' + '}', String(systemRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'systemRoleId' is not null or undefined
        if (systemRoleId === null || systemRoleId === undefined) {
            throw new Error('Required parameter systemRoleId was null or undefined when calling putSystemRole.');
        }
        // verify required parameter 'role' is not null or undefined
        if (role === null || role === undefined) {
            throw new Error('Required parameter role was null or undefined when calling putSystemRole.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: role,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     ユーザの情報を更新する。   </dd>   <dt>signature</dt>   <dd>     PUT /v1/users/{id}   </dd>   <dt>parameters</dt>   <dd>     ユーザの情報を更新する。     bodyに記述されたjson(#/definitions/User)の内容にしたがってプロジェクトの情報を更新する。     SYSTEM_USERを持つ場合に実行が可能。     変更の対象となるプロパティは以下の通り。これらのプロパティには必ず値が設定されていることを前提とする。     preference（null可）, systemRoleId（非null）, state（非null）     その他のプロパティは無視しても良い。createdは更新しない。updatedは自動的に更新する。   </dd>   <dt>return</dt>   <dd>     '#/definitions/User'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param userId ユーザID
     * @param self 自分自身の情報を更新するかどうか（プロファイル更新からの呼び出しかどうか）
     * @param user ユーザ
     */
    SystemApi.prototype.putUser = function (userId, self, user) {
        var localVarPath = this.basePath + '/users/{userId}'
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling putUser.');
        }
        // verify required parameter 'self' is not null or undefined
        if (self === null || self === undefined) {
            throw new Error('Required parameter self was null or undefined when calling putUser.');
        }
        // verify required parameter 'user' is not null or undefined
        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling putUser.');
        }
        if (self !== undefined) {
            queryParameters['self'] = self;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'PUT',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: user,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDで指定されるユーザのパスワードをリセットし、メールを送信する。   </dd>   <dt>signature</dt>   <dd>     POST /v1/users/{id}   </dd>   <dt>parameters</dt>   <dd>     ユーザのパスワードをリセットする。パスワードリセットのメールを送信する。     SYSTEM_USERを持つ場合に実行が可能。   </dd>   <dt>return</dt>   <dd>     '#/definitions/User'   </dd>   <dt>note</dt>   <dd>     jsonの内容が正しくない場合、必要な情報が設定されていない場合は400エラーとする。   </dd> </dl>
     * @param userId ユーザID
     */
    SystemApi.prototype.resetPassword = function (userId) {
        var localVarPath = this.basePath + '/users/{userId}'
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling resetPassword.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ストレージにアクセスするためのSASトークンを取得する。
     * @param sasPolicy アクセスポリシー
     */
    SystemApi.prototype.sasToken = function (sasPolicy) {
        var localVarPath = this.basePath + '/sasToken';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'sasPolicy' is not null or undefined
        if (sasPolicy === null || sasPolicy === undefined) {
            throw new Error('Required parameter sasPolicy was null or undefined when calling sasToken.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: sasPolicy,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * emailで指定されるメールアドレスにテストメールを送信する。
     * @param mail 送信先メールアドレス
     */
    SystemApi.prototype.sendTestMail = function (mail) {
        var localVarPath = this.basePath + '/mail';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'mail' is not null or undefined
        if (mail === null || mail === undefined) {
            throw new Error('Required parameter mail was null or undefined when calling sendTestMail.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: mail,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * システム権限を取得する。
     */
    SystemApi.prototype.systemAcl = function () {
        var localVarPath = this.basePath + '/acl';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * IDを指定してシステムロールを取得する。
     * @param systemRoleId システムロールID
     */
    SystemApi.prototype.systemRoleById = function (systemRoleId) {
        var localVarPath = this.basePath + '/systemRoles/{systemRoleId}'
            .replace('{' + 'systemRoleId' + '}', String(systemRoleId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'systemRoleId' is not null or undefined
        if (systemRoleId === null || systemRoleId === undefined) {
            throw new Error('Required parameter systemRoleId was null or undefined when calling systemRoleById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * ファイルのアップロード先を取得する。
     * @param uploadInfo アップロード情報
     */
    SystemApi.prototype.uploadTicket = function (uploadInfo) {
        var localVarPath = this.basePath + '/uploadTicket';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'uploadInfo' is not null or undefined
        if (uploadInfo === null || uploadInfo === undefined) {
            throw new Error('Required parameter uploadInfo was null or undefined when calling uploadTicket.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'POST',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
            body: uploadInfo,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * <dl>   <dt>function</dt>   <dd>     IDを指定してユーザを取得する。   </dd>   <dt>signature</dt>   <dd>     GET /v1/users/{id}   </dd>   <dt>parameters</dt>   <dd>     pathパラメータで指定されたIDを持つユーザを取得する。     例. /v1/users/1     SYSTEM_USER,SYSTEM_CREATE_PROJECT,SYSTEM_EDIT_PROJECTのうち一つ以上の権限を持つ場合に実行が可能。     指定されたIDを持つユーザについて全プロパティを設定して返す。   </dd>   <dt>return</dt>   <dd>     '#/definitions/User'   </dd>   <dt>note</dt>   <dd>     上記以外のリクエストパラメータの指定、組み合わせは400エラーとする。   </dd> </dl>
     * @param userId ユーザID
     */
    SystemApi.prototype.userById = function (userId) {
        var localVarPath = this.basePath + '/users/{userId}'
            .replace('{' + 'userId' + '}', String(userId));
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        // verify required parameter 'userId' is not null or undefined
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userById.');
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.Bearer.applyToRequest(requestOptions);
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return SystemApi;
}());
exports.SystemApi = SystemApi;
var UtilsApiApiKeys;
(function (UtilsApiApiKeys) {
    UtilsApiApiKeys[UtilsApiApiKeys["Bearer"] = 0] = "Bearer";
})(UtilsApiApiKeys = exports.UtilsApiApiKeys || (exports.UtilsApiApiKeys = {}));
var UtilsApi = /** @class */ (function () {
    function UtilsApi(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this.defaultHeaders = {};
        this._useQuerystring = false;
        this.authentications = {
            'default': new VoidAuth(),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    Object.defineProperty(UtilsApi.prototype, "useQuerystring", {
        set: function (value) {
            this._useQuerystring = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UtilsApi.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (basePath) {
            this._basePath = basePath;
        },
        enumerable: false,
        configurable: true
    });
    UtilsApi.prototype.setDefaultAuthentication = function (auth) {
        this.authentications.default = auth;
    };
    UtilsApi.prototype.setApiKey = function (key, value) {
        this.authentications[UtilsApiApiKeys[key]].apiKey = value;
    };
    /**
     * メッセージを返信する。
     * @param message 受信メッセージ
     */
    UtilsApi.prototype.hello = function (message) {
        var localVarPath = this.basePath + '/hello';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        if (message !== undefined) {
            queryParameters['message'] = message;
        }
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * サーバの現在時刻をUTCで取得する。
     */
    UtilsApi.prototype.time = function () {
        var localVarPath = this.basePath + '/time';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    /**
     * サーバの状態を取得する。
     */
    UtilsApi.prototype.getState = function () {
        var localVarPath = this.basePath + '/state';
        var queryParameters = {};
        var headerParams = Object.assign({}, this.defaultHeaders);
        var formParams = {};
        var useFormData = false;
        var requestOptions = {
            method: 'GET',
            qs: queryParameters,
            headers: headerParams,
            uri: localVarPath,
            useQuerystring: this._useQuerystring,
            json: true,
        };
        this.authentications.default.applyToRequest(requestOptions);
        if (Object.keys(formParams).length) {
            if (useFormData) {
                requestOptions.formData = formParams;
            }
            else {
                requestOptions.form = formParams;
            }
        }
        return new Promise(function (resolve, reject) {
            request(requestOptions, function (error, response, body) {
                if (error) {
                    reject(error);
                }
                else {
                    if (response.statusCode >= 200 && response.statusCode <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject({ response: response, body: body });
                    }
                }
            });
        });
    };
    return UtilsApi;
}());
exports.UtilsApi = UtilsApi;
